(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[3203],{

/***/ 59528:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(7046);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),

/***/ 36107:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),

/***/ 99393:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var isObject = function (obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
};
var isFunction = function (obj) { return typeof obj === "function"; };
var empty = function (obj) {
    if (isObject(obj)) {
        return {};
    }
    else if (Array.isArray(obj)) {
        return [];
    }
};
var keys = function (obj) {
    if (isObject(obj)) {
        return Object.getOwnPropertyNames(obj);
    }
    else {
        return Object.keys(obj);
    }
};
function defineProperties(obj, root) {
    var next = empty(obj);
    var props = keys(obj);
    if (!root) {
        root = next;
    }
    var _loop_1 = function (key) {
        var value = obj[key];
        if (isFunction(value)) {
            Object.defineProperty(next, key, {
                get: function () {
                    return value(root);
                },
                configurable: false,
                enumerable: true
            });
            return "continue";
        }
        if (Array.isArray(value) || isObject(value)) {
            Object.defineProperty(next, key, {
                value: defineProperties(value, root),
                configurable: false,
                enumerable: true
            });
            return "continue";
        }
        Object.defineProperty(next, key, {
            value: value,
            configurable: false,
            enumerable: true
        });
    };
    for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
        var key = props_1[_i];
        _loop_1(key);
    }
    return next;
}
exports.deepComputed = function (obj) {
    return defineProperties(obj);
};
exports["default"] = exports.deepComputed;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 73895:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(30242));
var invariant_1 = __importDefault(__webpack_require__(21700));
var deep_computed_1 = __webpack_require__(99393);
var utils_1 = __webpack_require__(13732);
exports.NO_CONTEXT_OR_DEFAULTS_ERROR = "Calling `useFlags()`, `useFlag()`, or `<Flag />` requires either that the application " +
    "is wrapped in a `<FlagsProvider />` or default flags are passed to `createFlags`.";
function createFlags(defaultFlags) {
    var contextDefaultValue = defaultFlags !== undefined ? defaultFlags : utils_1.noDefaultsSymbol;
    var Context = react_1.default.createContext(contextDefaultValue);
    Context.displayName = "Flag";
    var FlagsProvider = function (_a) {
        var flags = _a.flags, children = _a.children;
        var value = react_1.useMemo(function () { return deep_computed_1.deepComputed(flags); }, [flags]);
        return react_1.default.createElement(Context.Provider, { value: value }, children);
    };
    var useFlags = function () {
        var flags = react_1.useContext(Context);
        invariant_1.default(flags !== utils_1.noDefaultsSymbol, exports.NO_CONTEXT_OR_DEFAULTS_ERROR);
        return flags;
    };
    var useFlag = function (keyPath, defaultValue) {
        var flags = react_1.useContext(Context);
        /**
         * TypeScript will complain about returning if the value
         * is `KeyPathValue<T, KP>`, so just type it as `any`.
         */
        var value = defaultValue;
        if (flags === utils_1.noDefaultsSymbol && value !== undefined) {
            return value;
        }
        invariant_1.default(flags !== utils_1.noDefaultsSymbol, exports.NO_CONTEXT_OR_DEFAULTS_ERROR);
        var result = flags;
        for (var _i = 0, _a = keyPath; _i < _a.length; _i++) {
            var next = _a[_i];
            /**
             * This trap is unreachable in TypeScript.
             */
            if (utils_1.isObject(result) && !(next in result)) {
                return undefined;
            }
            result = result[next];
        }
        return result;
    };
    function Flag(props) {
        var flags = useFlags();
        var flag = useFlag(props.name);
        var isEnabled = Boolean(flag);
        if (isEnabled && "children" in props) {
            return props.children;
        }
        if (isEnabled && "render" in props) {
            return props.render(flags);
        }
        if (isEnabled && "component" in props) {
            var Component = props.component;
            return react_1.default.createElement(Component, { flags: flags });
        }
        if (!isEnabled && "fallbackRender" in props && props.fallbackRender) {
            return props.fallbackRender(flags);
        }
        if (!isEnabled && "fallbackComponent" in props && props.fallbackComponent) {
            var Component = props.fallbackComponent;
            return react_1.default.createElement(Component, { flags: flags });
        }
        return null;
    }
    return {
        FlagsProvider: FlagsProvider,
        Flag: Flag,
        useFlag: useFlag,
        useFlags: useFlags
    };
}
exports.createFlags = createFlags;
exports["default"] = createFlags;


/***/ }),

/***/ 18988:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var create_flags_1 = __webpack_require__(73895);
__webpack_unused_export__ = create_flags_1.createFlags;
exports.ZP = create_flags_1.createFlags;


/***/ }),

/***/ 13732:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function isObject(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
exports.isObject = isObject;
exports.noDefaultsSymbol = Symbol("@@FLAG_NO_DEFAULTS");


/***/ }),

/***/ 72221:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   XG: () => (/* binding */ getOverride),
/* harmony export */   aO: () => (/* binding */ mergeOverrides),
/* harmony export */   ch: () => (/* binding */ getOverrideProps),
/* harmony export */   hq: () => (/* binding */ toObjectOverride),
/* harmony export */   jb: () => (/* binding */ getOverrides),
/* harmony export */   vt: () => (/* binding */ mergeOverride)
/* harmony export */ });
/* unused harmony exports mergeConfigurationOverrides, useOverrides */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99415);
/* harmony import */ var _utils_deep_merge_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69176);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable cup/no-undef */




/**
 * Given an override argument, returns the component implementation override if it exists
 */
// eslint-disable-next-line flowtype/no-weak-types
function getOverride(override) {
  if ((0,react_is__WEBPACK_IMPORTED_MODULE_1__.isValidElementType)(override)) {
    return override;
  } // Check if override is OverrideObjectT


  if (override && _typeof(override) === 'object') {
    // Remove this 'any' once this flow issue is fixed:
    // https://github.com/facebook/flow/issues/6666
    // eslint-disable-next-line flowtype/no-weak-types
    return override.component;
  } // null/undefined


  return override;
}
/**
 * Given an override argument, returns the override props that should be passed
 * to the component when rendering it.
 */

function getOverrideProps(override) {
  if (override && _typeof(override) === 'object') {
    if (_typeof(override.props) === 'object') {
      return _objectSpread(_objectSpread({}, override.props), {}, {
        $style: override.style
      });
    } else {
      return {
        $style: override.style
      };
    }
  }

  return {};
}
/**
 * Coerces an override argument into an override object
 * (sometimes it is just an override component)
 */

function toObjectOverride(override) {
  if ((0,react_is__WEBPACK_IMPORTED_MODULE_1__.isValidElementType)(override)) {
    return {
      // eslint-disable-next-line flowtype/no-weak-types
      component: override
    };
  } // Flow can't figure out that typeof 'function' above will
  // catch React.StatelessFunctionalComponent
  // (probably related to https://github.com/facebook/flow/issues/6666)
  // eslint-disable-next-line flowtype/no-weak-types


  return override || {};
}
/**
 * Get a convenient override array that will always have [component, props]
 */

/* eslint-disable flowtype/no-weak-types */

function getOverrides(override, defaultComponent) {
  var Component = getOverride(override) || defaultComponent;

  if (override && _typeof(override) === 'object' && typeof override.props === 'function') {
    // TODO(v11)
    if (false) {}

    var DynamicOverride = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
      var mappedProps = override.props(props);
      var nextProps = getOverrideProps(_objectSpread(_objectSpread({}, override), {}, {
        props: mappedProps
      }));
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _extends({
        ref: ref
      }, nextProps));
    });
    DynamicOverride.displayName = Component.displayName;
    return [DynamicOverride, {}];
  }

  var props = getOverrideProps(override);
  return [Component, props];
}
/* eslint-enable flowtype/no-weak-types */

/**
 * Merges two overrides objects – this is useful if you want to inject your own
 * overrides into a child component, but also accept further overrides from
 * from upstream. See `mergeOverride` below.
 */

function mergeOverrides() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var merged = Object.assign({}, target, source);
  var allIdentifiers = Object.keys(merged); // const allIdentifiers = Object.keys({...target, ...source});

  return allIdentifiers.reduce(function (acc, name) {
    acc[name] = mergeOverride(toObjectOverride(target[name]), toObjectOverride(source[name]));
    return acc;
  }, {});
}
/**
 * Merges two override objects using the following behavior:
 * - Component implementation from the source (parent) replaces target
 * - Props and styles are both deep merged
 */

function mergeOverride(target, source) {
  // Shallow merge should handle `component`
  var merged = _objectSpread(_objectSpread({}, target), source);

  if (target.props && source.props) {
    merged.props = mergeConfigurationOverrides(target.props, source.props);
  }

  if (target.style && source.style) {
    merged.style = mergeConfigurationOverrides(target.style, source.style);
  }

  return merged;
}
/**
 * Since style or props overrides can be an object *or* a function, we need to handle
 * the case that one of them is a function. We do this by returning a new
 * function that deep merges the result of each style override
 */

function mergeConfigurationOverrides(target, source) {
  // Simple case of both objects
  if (_typeof(target) === 'object' && _typeof(source) === 'object') {
    return (0,_utils_deep_merge_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, target, source);
  } // At least one is a function, return a new composite function


  return function () {
    return (0,_utils_deep_merge_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, typeof target === 'function' ? target.apply(void 0, arguments) : target, typeof source === 'function' ? source.apply(void 0, arguments) : source);
  };
} // Lil' hook for memoized unpacking of overrides

function useOverrides(defaults) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return React.useMemo(function () {
    return (// eslint-disable-next-line flowtype/no-weak-types
      Object.keys(defaults).reduce(function (obj, key) {
        obj[key] = getOverrides(overrides[key], defaults[key]);
        return obj;
      }, {})
    );
  }, [overrides]);
}

/***/ }),

/***/ 80497:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: () => (/* binding */ getMediaQueries),
/* harmony export */   a: () => (/* binding */ getMediaQuery)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/**
 * Helper function that generates media queries based on breakpoint, e.g.
 * getMediaQuery(720) => '@media screen and (min-width: 720px)'
 */
var getMediaQuery = function getMediaQuery(breakpoint) {
  return "@media screen and (min-width: ".concat(breakpoint, "px)");
};
var getMediaQueries = function getMediaQueries(breakpoints) {
  return Object.keys(breakpoints).map(function (key) {
    return breakpoints[key];
  }).sort(function (a, b) {
    return a - b;
  }).map(getMediaQuery);
};

/***/ }),

/***/ 15149:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var _helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72221);
/* harmony import */ var _icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11614);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-REACT-ICON
// DO NOT EDIT THIS FILE DIRECTLY, SEE README.md





function Delete(props, ref) {
  var _useStyletron = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)(),
      _useStyletron2 = _slicedToArray(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Delete' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .mergeOverride */ .vt)( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.Delete ? theme.icons.Delete : null
  }, overrides && overrides.Svg ? (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .toObjectOverride */ .hq)(overrides.Svg) : {});
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _extends({
    viewBox: "0 0 24 24",
    ref: ref,
    title: title,
    size: size,
    color: color,
    overrides: {
      Svg: SvgOverride
    }
  }, restProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289Z"
  }));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Delete));

/***/ }),

/***/ 11614:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ icon)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/overrides.js
var helpers_overrides = __webpack_require__(72221);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(74995);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/omit-dollar-prefixed-keys.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// eslint-disable-next-line flowtype/no-weak-types
function omitDollarPrefixedKeys(source) {
  var result = {};

  for (var key in source) {
    if (key[0] !== '$') {
      result[key] = source[key];
    }
  }

  return result;
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/icon.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/





function Icon(props, ref) {
  var children = props.children,
      title = props.title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties(props, ["children", "title", "size", "color", "overrides"]);

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.Svg, styled_components/* Svg */.n),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      Svg = _getOverrides2[0],
      overrideProps = _getOverrides2[1]; // Determine how/which props are passed based on if the component is a Styletron component.
  // $FlowFixMe: __STYLETRON__ not in React.AbstractcomponentStatics


  var passThroughProps = Svg.__STYLETRON__ ? _objectSpread(_objectSpread({
    title: title,
    $color: color,
    $size: size
  }, restProps), overrideProps) : _objectSpread(_objectSpread({
    title: title,
    color: color,
    size: size
  }, omitDollarPrefixedKeys(restProps)), omitDollarPrefixedKeys(overrideProps));
  return /*#__PURE__*/react.createElement(Svg, _extends({
    "data-baseweb": "icon",
    ref: ref
  }, passThroughProps), title ? /*#__PURE__*/react.createElement("title", null, title) : null, children);
}

/* harmony default export */ const icon = (/*#__PURE__*/react.forwardRef(Icon));

/***/ }),

/***/ 74995:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   n: () => (/* binding */ Svg),
/* harmony export */   u: () => (/* binding */ getSvgStyles)
/* harmony export */ });
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

function getSvgStyles(_ref) {
  var $theme = _ref.$theme,
      $size = _ref.$size,
      $color = _ref.$color;
  var size = $theme.sizing.scale600;

  if ($size) {
    if ($theme.sizing[$size]) {
      size = $theme.sizing[$size];
    } else if (typeof $size === 'number') {
      size = "".concat($size, "px");
    } else {
      size = $size;
    }
  }

  var color = 'currentColor';

  if ($color) {
    if ($theme.colors[$color]) {
      color = $theme.colors[$color];
    } else {
      color = $color;
    }
  }

  return {
    display: 'inline-block',
    fill: color,
    color: color,
    height: size,
    width: size
  };
}
var Svg = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('svg', getSvgStyles);
Svg.displayName = "Svg";

/***/ }),

/***/ 47903:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: () => (/* binding */ TETHER_PLACEMENT)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var TETHER_PLACEMENT = {
  auto: 'auto',
  topLeft: 'topLeft',
  top: 'top',
  topRight: 'topRight',
  rightTop: 'rightTop',
  right: 'right',
  rightBottom: 'rightBottom',
  bottomRight: 'bottomRight',
  bottom: 'bottom',
  bottomLeft: 'bottomLeft',
  leftBottom: 'leftBottom',
  left: 'left',
  leftTop: 'leftTop'
};

/***/ }),

/***/ 17655:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ Layer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5556);
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10334);
/* harmony import */ var _layers_manager_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24747);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* global document */




var Container = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)('div', function (_ref) {
  var $zIndex = _ref.$zIndex;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: $zIndex || null
  };
});
Container.displayName = "Container";

var LayerComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(LayerComponent, _React$Component);

  var _super = _createSuper(LayerComponent);

  function LayerComponent() {
    var _this;

    _classCallCheck(this, LayerComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      container: null
    });

    _defineProperty(_assertThisInitialized(_this), "onEscape", function () {
      if (_this.props.onEscape) {
        _this.props.onEscape();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDocumentClick", function (event) {
      if (_this.props.onDocumentClick) {
        _this.props.onDocumentClick(event);
      }
    });

    return _this;
  }

  _createClass(LayerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.addEscapeHandler(this.onEscape);

      if (!this.props.isHoverLayer) {
        this.context.addDocClickHandler(this.onDocumentClick);
      }

      var _this$props = this.props,
          onMount = _this$props.onMount,
          mountNode = _this$props.mountNode,
          layersManagerHost = _this$props.host;

      if (mountNode) {
        onMount && onMount();
        return;
      } // There was no LayersManager added if this.props.host === undefined.
      // Use document.body is the case no LayersManager is used.


      var hasLayersManager = layersManagerHost !== undefined;

      if (false) {}

      var host = hasLayersManager ? layersManagerHost : document.body;

      if (host) {
        this.addContainer(host);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          host = _this$props2.host,
          mountNode = _this$props2.mountNode;

      if (mountNode) {
        return;
      }

      if (host && host !== prevProps.host && prevProps.host === null) {
        this.addContainer(host);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.removeEscapeHandler(this.onEscape);
      this.context.removeDocClickHandler(this.onDocumentClick);

      if (this.props.onUnmount) {
        this.props.onUnmount();
      }

      var host = this.props.host;
      var container = this.state.container;

      if (host && container) {
        if (host.contains(container)) {
          host.removeChild(container);
        }
      }
    }
  }, {
    key: "addContainer",
    value: function addContainer(host) {
      var _this$props3 = this.props,
          index = _this$props3.index,
          mountNode = _this$props3.mountNode,
          onMount = _this$props3.onMount; // Do nothing if mountNode is provided

      if (mountNode) {
        return;
      }

      if (host) {
        var container = host.ownerDocument.createElement('div'); // `host` is an DOM node, but not a React component

        var sibling = typeof index === 'number' ? host.children[index] : null;
        sibling ? host.insertBefore(container, sibling) : host.appendChild(container);
        this.setState({
          container: container
        }, function () {
          onMount && onMount();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var container = this.state.container;
      var _this$props4 = this.props,
          children = _this$props4.children,
          mountNode = _this$props4.mountNode,
          zIndex = _this$props4.zIndex; // Only adding an additional wrapper when a layer has z-index to be set

      var childrenToRender = zIndex ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, {
        $zIndex: zIndex
      }, children) : children;

      if (typeof document !== 'undefined') {
        if (mountNode || container) {
          // $FlowFixMe
          return /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(childrenToRender, mountNode || container);
        }

        return null;
      }

      return null;
    }
  }]);

  return LayerComponent;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

_defineProperty(LayerComponent, "contextType", _layers_manager_js__WEBPACK_IMPORTED_MODULE_3__/* .LayersContext */ .rH);

function Layer(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_layers_manager_js__WEBPACK_IMPORTED_MODULE_3__/* .Consumer */ .$6, null, function (_ref2) {
    var host = _ref2.host,
        zIndex = _ref2.zIndex;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(LayerComponent, _extends({}, props, {
      host: host,
      zIndex: zIndex
    }));
  });
}

/***/ }),

/***/ 24747:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $6: () => (/* binding */ Consumer),
/* harmony export */   ZP: () => (/* binding */ LayersManager),
/* harmony export */   rH: () => (/* binding */ LayersContext)
/* harmony export */ });
/* unused harmony export Provider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var _helpers_overrides_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72221);
/* harmony import */ var _utils_focusVisible_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27247);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/




var StyledAppContainer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('div', {});
StyledAppContainer.displayName = "StyledAppContainer";
var StyledLayersContainer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('div', {});
StyledLayersContainer.displayName = "StyledLayersContainer";

function defaultEventHandlerFn() {
  if (false) {}
}

var LayersContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  addEscapeHandler: defaultEventHandlerFn,
  removeEscapeHandler: defaultEventHandlerFn,
  addDocClickHandler: defaultEventHandlerFn,
  removeDocClickHandler: defaultEventHandlerFn,
  host: undefined,
  zIndex: undefined
});
var Provider = LayersContext.Provider;
var Consumer = LayersContext.Consumer;

var LayersManager = /*#__PURE__*/function (_React$Component) {
  _inherits(LayersManager, _React$Component);

  var _super = _createSuper(LayersManager);

  function LayersManager(props) {
    var _this;

    _classCallCheck(this, LayersManager);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "host", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createRef());

    _defineProperty(_assertThisInitialized(_this), "containerRef", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createRef());

    _defineProperty(_assertThisInitialized(_this), "onDocumentClick", function (event) {
      var docClickHandler = _this.state.docClickHandlers[_this.state.docClickHandlers.length - 1];

      if (docClickHandler) {
        docClickHandler(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyUp", function (event) {
      if (event.key === 'Escape') {
        var escapeKeyHandler = _this.state.escapeKeyHandlers[_this.state.escapeKeyHandlers.length - 1];

        if (escapeKeyHandler) {
          escapeKeyHandler();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAddEscapeHandler", function (escapeKeyHandler) {
      _this.setState(function (prev) {
        return {
          escapeKeyHandlers: [].concat(_toConsumableArray(prev.escapeKeyHandlers), [escapeKeyHandler])
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveEscapeHandler", function (escapeKeyHandler) {
      _this.setState(function (prev) {
        return {
          escapeKeyHandlers: prev.escapeKeyHandlers.filter(function (handler) {
            return handler !== escapeKeyHandler;
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddDocClickHandler", function (docClickHandler) {
      _this.setState(function (prev) {
        return {
          docClickHandlers: [].concat(_toConsumableArray(prev.docClickHandlers), [docClickHandler])
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveDocClickHandler", function (docClickHandler) {
      _this.setState(function (prev) {
        return {
          docClickHandlers: prev.docClickHandlers.filter(function (handler) {
            return handler !== docClickHandler;
          })
        };
      });
    });

    _this.state = {
      escapeKeyHandlers: [],
      docClickHandlers: []
    };
    return _this;
  }

  _createClass(LayersManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate();
      (0,_utils_focusVisible_js__WEBPACK_IMPORTED_MODULE_2__/* .initFocusVisible */ .L)(this.containerRef.current);

      if (typeof document !== 'undefined') {
        document.addEventListener('keyup', this.onKeyUp); // using mousedown event so that callback runs before events on children inside of the layer

        document.addEventListener('mousedown', this.onDocumentClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('keyup', this.onKeyUp);
        document.removeEventListener('mousedown', this.onDocumentClick);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_3__/* .getOverrides */ .jb)(overrides.AppContainer, StyledAppContainer),
          _getOverrides2 = _slicedToArray(_getOverrides, 2),
          AppContainer = _getOverrides2[0],
          appContainerProps = _getOverrides2[1];

      var _getOverrides3 = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_3__/* .getOverrides */ .jb)(overrides.LayersContainer, StyledLayersContainer),
          _getOverrides4 = _slicedToArray(_getOverrides3, 2),
          LayersContainer = _getOverrides4[0],
          layersContainerProps = _getOverrides4[1];

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Consumer, null, function (_ref) {
        var host = _ref.host;

        if (false) {}

        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Provider, {
          value: {
            host: host || _this2.host.current,
            zIndex: _this2.props.zIndex,
            addEscapeHandler: _this2.onAddEscapeHandler,
            removeEscapeHandler: _this2.onRemoveEscapeHandler,
            addDocClickHandler: _this2.onAddDocClickHandler,
            removeDocClickHandler: _this2.onRemoveDocClickHandler
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppContainer, _extends({}, appContainerProps, {
          ref: _this2.containerRef
        }), _this2.props.children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(LayersContainer, _extends({}, layersContainerProps, {
          ref: _this2.host
        })));
      });
    }
  }]);

  return LayersManager;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);



/***/ }),

/***/ 50055:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ tether)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/popper.js@1.16.1/node_modules/popper.js/dist/esm/popper.js
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : __webpack_require__.g).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ const popper = (Popper);
//# sourceMappingURL=popper.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/layer/utils.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function toPopperPlacement(placement) {
  return placement.replace(/(Top|Left)$/, '-start').replace(/(Right|Bottom)$/, '-end');
}
/**
 * Takes the offset passed from popper.js and normalizes it
 */

function parsePopperOffset(offset) {
  return {
    top: Math.floor(offset.top || 0),
    left: Math.floor(offset.left || 0)
  };
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/layer/constants.js
var constants = __webpack_require__(47903);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/layer/tether.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/





var Tether = /*#__PURE__*/function (_React$Component) {
  _inherits(Tether, _React$Component);

  var _super = _createSuper(Tether);

  function Tether() {
    var _this;

    _classCallCheck(this, Tether);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "popper", void 0);

    _defineProperty(_assertThisInitialized(_this), "popperHeight", 0);

    _defineProperty(_assertThisInitialized(_this), "popperWidth", 0);

    _defineProperty(_assertThisInitialized(_this), "anchorHeight", 0);

    _defineProperty(_assertThisInitialized(_this), "anchorWidth", 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isMounted: false
    });

    _defineProperty(_assertThisInitialized(_this), "onPopperUpdate", function (data) {
      var normalizedOffsets = {
        popper: parsePopperOffset(data.offsets.popper),
        arrow: data.offsets.arrow ? parsePopperOffset(data.offsets.arrow) : {
          top: 0,
          left: 0
        }
      };

      _this.props.onPopperUpdate(normalizedOffsets, data);
    });

    return _this;
  }

  _createClass(Tether, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Handles the case where popover content changes size and creates a gap between the anchor and
      // the popover. Popper.js only schedules updates on resize and scroll events. In the case of
      // the Select component, when options were filtered in the dropdown menu it creates a gap
      // between it and the input element.
      if (this.props.anchorRef) {
        var _this$props$anchorRef = this.props.anchorRef.getBoundingClientRect(),
            height = _this$props$anchorRef.height,
            width = _this$props$anchorRef.width;

        if (this.anchorHeight !== height || this.anchorWidth !== width) {
          this.anchorHeight = height;
          this.anchorWidth = width;
          this.popper && this.popper.scheduleUpdate();
        }
      }

      if (this.props.popperRef) {
        var _this$props$popperRef = this.props.popperRef.getBoundingClientRect(),
            _height = _this$props$popperRef.height,
            _width = _this$props$popperRef.width;

        if (this.popperHeight !== _height || this.popperWidth !== _width) {
          this.popperHeight = _height;
          this.popperWidth = _width;
          this.popper && this.popper.scheduleUpdate();
        }

        if (this.state.isMounted !== prevState.isMounted) {
          if (!this.props.anchorRef) {
            if (false) {}
          } else {
            this.initializePopper();
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyPopover();
    }
  }, {
    key: "initializePopper",
    value: function initializePopper() {
      var _this$props = this.props,
          placement = _this$props.placement,
          popperOptions = _this$props.popperOptions;

      var modifiers = popperOptions.modifiers,
          restOptions = _objectWithoutProperties(popperOptions, ["modifiers"]);

      if (!this.props.anchorRef || !this.props.popperRef) return;
      this.popper = new popper(this.props.anchorRef, this.props.popperRef, _objectSpread({
        // Recommended placement (popper may ignore if it causes a viewport overflow, etc)
        placement: toPopperPlacement(placement),
        modifiers: _objectSpread({
          // Passing the arrow ref will measure the arrow when calculating styles
          arrow: {
            element: this.props.arrowRef,
            enabled: !!this.props.arrowRef
          },
          computeStyle: {
            // Make popper use top/left instead of transform translate, this is because
            // we use transform for animations and we dont want them to conflict
            gpuAcceleration: false
          },
          applyStyle: {
            // Disable default styling modifier, we'll apply styles on our own
            enabled: false
          },
          applyReactStyle: {
            enabled: true,
            fn: this.onPopperUpdate,
            order: 900
          },
          preventOverflow: {
            enabled: true
          }
        }, modifiers)
      }, restOptions));
    }
  }, {
    key: "destroyPopover",
    value: function destroyPopover() {
      if (this.popper) {
        this.popper.destroy();
        delete this.popper;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return Tether;
}(react.Component);

_defineProperty(Tether, "defaultProps", {
  anchorRef: null,
  onPopperUpdate: function onPopperUpdate() {
    return null;
  },
  placement: constants/* TETHER_PLACEMENT */.Q.auto,
  popperRef: null,
  popperOptions: {}
});

/* harmony default export */ const tether = (Tether);

/***/ }),

/***/ 1785:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  R: () => (/* binding */ LocaleContext)
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/just-extend@4.1.0/node_modules/just-extend/index.js
var just_extend = __webpack_require__(53269);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/accordion/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale = {
  collapse: 'Collapse',
  expand: 'Expand'
};
/* harmony default export */ const accordion_locale = (locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/breadcrumbs/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale_locale = {
  ariaLabel: 'Breadcrumbs navigation'
};
/* harmony default export */ const breadcrumbs_locale = (locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/datepicker/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var datepicker_locale_locale = {
  ariaLabel: 'Select a date.',
  ariaLabelRange: 'Select a date range.',
  ariaLabelCalendar: 'Calendar.',
  ariaRoleDescriptionCalendarMonth: 'Calendar month',
  previousMonth: 'Previous month.',
  nextMonth: 'Next month.',
  pastWeek: 'Past Week',
  pastMonth: 'Past Month',
  pastThreeMonths: 'Past 3 Months',
  pastSixMonths: 'Past 6 Months',
  pastYear: 'Past Year',
  pastTwoYears: 'Past 2 Years',
  screenReaderMessageInput: 'Press the down arrow key to interact with the calendar and select a date. Press the escape button to close the calendar.',
  selectedDate: 'Selected date is ${date}.',
  selectedDateRange: 'Selected date range is from ${startDate} to ${endDate}.',
  selectSecondDatePrompt: 'Select the second date.',
  quickSelectLabel: 'Choose a date range',
  quickSelectAriaLabel: 'Choose a date range',
  quickSelectPlaceholder: 'None',
  timeSelectEndLabel: 'End time',
  timeSelectStartLabel: 'Start time',
  timePickerAriaLabel12Hour: 'Select a time, 12-hour format.',
  timePickerAriaLabel24Hour: 'Select a time, 24-hour format.',
  timezonePickerAriaLabel: 'Select a timezone.',
  selectedStartDateLabel: 'Selected start date.',
  selectedEndDateLabel: 'Selected end date.',
  dateNotAvailableLabel: 'Not available.',
  dateAvailableLabel: "It's available.",
  selectedLabel: 'Selected.',
  chooseLabel: 'Choose'
};
/* harmony default export */ const datepicker_locale = (datepicker_locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/data-table/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var data_table_locale_locale = {
  emptyState: 'No rows match the filter criteria defined. Please remove one or more filters to view more data.',
  loadingState: 'Loading Rows.',
  searchAriaLabel: 'Search by text',
  filterAdd: 'Add Filter',
  filterExclude: 'Exclude',
  filterApply: 'Apply',
  filterAppliedTo: 'filter applied to',
  optionsLabel: 'Select column to filter by',
  optionsSearch: 'Search for a column to filter by...',
  optionsEmpty: 'No columns available.',
  categoricalFilterSelectAll: 'Select All',
  categoricalFilterSelectClear: 'Clear',
  categoricalFilterEmpty: 'No Categories Found',
  datetimeFilterRange: 'Range',
  datetimeFilterRangeDatetime: 'Date, Time',
  datetimeFilterRangeDate: 'Date',
  datetimeFilterRangeTime: 'Time',
  datetimeFilterCategorical: 'Categorical',
  datetimeFilterCategoricalWeekday: 'Weekday',
  datetimeFilterCategoricalMonth: 'Month',
  datetimeFilterCategoricalQuarter: 'Quarter',
  datetimeFilterCategoricalHalf: 'Half',
  datetimeFilterCategoricalFirstHalf: 'H1',
  datetimeFilterCategoricalSecondHalf: 'H2',
  datetimeFilterCategoricalYear: 'Year',
  numericalFilterRange: 'Range',
  numericalFilterSingleValue: 'Single Value',
  booleanFilterTrue: 'true',
  booleanFilterFalse: 'false',
  booleanColumnTrueShort: 'T',
  booleanColumnFalseShort: 'F'
};
/* harmony default export */ const data_table_locale = (data_table_locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button-group/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var button_group_locale_locale = {
  ariaLabel: 'button group'
};
/* harmony default export */ const button_group_locale = (button_group_locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/file-uploader/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var file_uploader_locale_locale = {
  dropFilesToUpload: 'Drop files here to upload...',
  or: '',
  browseFiles: 'Browse files',
  retry: 'Retry Upload',
  cancel: 'Cancel'
};
/* harmony default export */ const file_uploader_locale = (file_uploader_locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var menu_locale_locale = {
  noResultsMsg: 'No results',
  parentMenuItemAriaLabel: "You are currently at an item that opens a nested listbox. Press right arrow to enter that element and left arrow to return."
};
/* harmony default export */ const menu_locale = (menu_locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/modal/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var modal_locale_locale = {
  close: 'Close'
};
/* harmony default export */ const modal_locale = (modal_locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/drawer/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var drawer_locale_locale = {
  close: 'Close'
};
/* harmony default export */ const drawer_locale = (drawer_locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/pagination/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var pagination_locale_locale = {
  prev: 'Prev',
  next: 'Next',
  preposition: 'of'
};
/* harmony default export */ const pagination_locale = (pagination_locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/select/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var select_locale_locale = {
  // Remove noResultsMsg prop in the next major version
  noResultsMsg: 'No results found',
  placeholder: 'Select...',
  create: 'Create'
};
/* harmony default export */ const select_locale = (select_locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/toast/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var toast_locale_locale = {
  close: 'Close'
};
/* harmony default export */ const toast_locale = (toast_locale_locale);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/locale/en_US.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/












var en_US_en_US = {
  accordion: accordion_locale,
  breadcrumbs: breadcrumbs_locale,
  datepicker: datepicker_locale,
  datatable: data_table_locale,
  buttongroup: button_group_locale,
  fileuploader: file_uploader_locale,
  menu: menu_locale,
  modal: modal_locale,
  drawer: drawer_locale,
  pagination: pagination_locale,
  select: select_locale,
  toast: toast_locale
};
/* harmony default export */ const locale_en_US = (en_US_en_US);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/locale/index.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



var LocaleContext = /*#__PURE__*/react.createContext(locale_en_US);

var LocaleProvider = function LocaleProvider(props) {
  var locale = props.locale,
      children = props.children;

  if (false) {}

  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: extend({}, en_US, locale)
  }, children);
};

/* harmony default export */ const esm_locale = ((/* unused pure expression or super */ null && (LocaleProvider)));

/***/ }),

/***/ 64165:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AF: () => (/* binding */ POPOVER_MARGIN),
/* harmony export */   Pd: () => (/* binding */ ANIMATE_OUT_TIME),
/* harmony export */   SI: () => (/* binding */ ACCESSIBILITY_TYPE),
/* harmony export */   YM: () => (/* binding */ ARROW_SIZE),
/* harmony export */   gu: () => (/* binding */ TRIGGER_TYPE),
/* harmony export */   jt: () => (/* binding */ ANIMATE_IN_TIME),
/* harmony export */   mb: () => (/* binding */ ARROW_WIDTH),
/* harmony export */   oL: () => (/* binding */ STATE_CHANGE_TYPE),
/* harmony export */   r4: () => (/* binding */ PLACEMENT)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var PLACEMENT = {
  auto: 'auto',
  topLeft: 'topLeft',
  top: 'top',
  topRight: 'topRight',
  rightTop: 'rightTop',
  right: 'right',
  rightBottom: 'rightBottom',
  bottomRight: 'bottomRight',
  bottom: 'bottom',
  bottomLeft: 'bottomLeft',
  leftBottom: 'leftBottom',
  left: 'left',
  leftTop: 'leftTop'
};
var TRIGGER_TYPE = {
  click: 'click',
  hover: 'hover'
};
var STATE_CHANGE_TYPE = {
  open: 'open',
  close: 'close'
};
var ACCESSIBILITY_TYPE = {
  none: 'none',
  menu: 'menu',
  tooltip: 'tooltip'
};
var POPOVER_MARGIN = 8;
var ARROW_SIZE = 6;
var ANIMATE_OUT_TIME = 0;
var ANIMATE_IN_TIME = 20;
/**
 * Since we use a 45-degree rotated div to render the arrow, the
 * width/height of this div is different than the arrow size itself
 *
 * The arrow size is essentially half the diagonal of the rotated div,
 * using pythagorean theorem:
 *   width^2 + height^2 = (arrow_size * 2)^2
 * In this case width = height so:
 *   2 * width^2 = (arrow_size * 2)^2
 * Simplifies to:
 *   width = √((arrow_size * 2)^2 / 2)
 */

var ARROW_WIDTH = Math.ceil(Math.sqrt(Math.pow(ARROW_SIZE * 2, 2) / 2));

/***/ }),

/***/ 2493:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ popover)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-focus-lock@2.9.6_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-focus-lock/dist/es2015/index.js + 28 modules
var es2015 = __webpack_require__(86946);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/overrides.js
var helpers_overrides = __webpack_require__(72221);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/constants.js
var constants = __webpack_require__(64165);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/layer/layer.js
var layer_layer = __webpack_require__(17655);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/layer/tether.js + 2 modules
var tether = __webpack_require__(50055);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/styled-components.js
var styled_components = __webpack_require__(72421);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/utils.js
var utils = __webpack_require__(43875);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/default-props.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var baseDefaultProps = {
  accessibilityType: constants/* ACCESSIBILITY_TYPE */.SI.menu,
  focusLock: false,
  autoFocus: true,
  returnFocus: true,
  // Remove the `ignoreBoundary` prop in the next major version
  // and have it replaced with the TetherBehavior props overrides
  ignoreBoundary: false,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: constants/* PLACEMENT */.r4.auto,
  showArrow: false,
  triggerType: constants/* TRIGGER_TYPE */.gu.click,
  renderAll: false
};
/* harmony default export */ const default_props = (baseDefaultProps);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/hooks.js
var hooks = __webpack_require__(4689);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/popover.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable react/no-find-dom-node */

/* eslint-disable cup/no-undef */










var PopoverInner = /*#__PURE__*/function (_React$Component) {
  _inherits(PopoverInner, _React$Component);

  var _super = _createSuper(PopoverInner);

  function PopoverInner() {
    var _this;

    _classCallCheck(this, PopoverInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "animateInTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "animateOutTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "animateOutCompleteTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "onMouseEnterTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "onMouseLeaveTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "anchorRef", /*#__PURE__*/react.createRef());

    _defineProperty(_assertThisInitialized(_this), "popperRef", /*#__PURE__*/react.createRef());

    _defineProperty(_assertThisInitialized(_this), "arrowRef", /*#__PURE__*/react.createRef());

    _defineProperty(_assertThisInitialized(_this), "state", _this.getDefaultState(_this.props));

    _defineProperty(_assertThisInitialized(_this), "animateIn", function () {
      if (_this.props.isOpen) {
        _this.setState({
          isAnimating: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "animateOut", function () {
      if (!_this.props.isOpen) {
        _this.setState({
          isAnimating: true
        }); // Remove the popover from the DOM after animation finishes


        _this.animateOutCompleteTimer = setTimeout(function () {
          _this.setState({
            isAnimating: false,
            // Reset to ideal placement specified in props
            placement: _this.props.placement
          });
        }, _this.props.animateOutTime || constants/* ANIMATE_OUT_TIME */.Pd);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAnchorClick", function (e) {
      if (_this.props.onClick) {
        _this.props.onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAnchorMouseEnter", function (e) {
      // First clear any existing close timers, this ensures that the user can
      // move their mouse from the popover back to anchor without it hiding
      if (_this.onMouseLeaveTimer) {
        clearTimeout(_this.onMouseLeaveTimer);
      }

      _this.triggerOnMouseEnterWithDelay(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onAnchorMouseLeave", function (e) {
      // Clear any existing open timer, otherwise popover could be stuck open
      if (_this.onMouseEnterTimer) {
        clearTimeout(_this.onMouseEnterTimer);
      }

      _this.triggerOnMouseLeaveWithDelay(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onPopoverMouseEnter", function () {
      if (_this.onMouseLeaveTimer) {
        clearTimeout(_this.onMouseLeaveTimer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPopoverMouseLeave", function (e) {
      _this.triggerOnMouseLeaveWithDelay(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onPopperUpdate", function (normalizedOffsets, data) {
      var placement = (0,utils/* fromPopperPlacement */.PR)(data.placement) || constants/* PLACEMENT */.r4.top;

      _this.setState({
        arrowOffset: normalizedOffsets.arrow,
        popoverOffset: normalizedOffsets.popper,
        placement: placement
      }); // Now that element has been positioned, we can animate it in


      _this.animateInTimer = setTimeout(_this.animateIn, constants/* ANIMATE_IN_TIME */.jt);
      return data;
    });

    _defineProperty(_assertThisInitialized(_this), "triggerOnMouseLeave", function (e) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "triggerOnMouseEnter", function (e) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDocumentClick", function (evt) {
      //$FlowFixMe
      var target = evt.composedPath ? evt.composedPath()[0] : evt.target;
      var popper = _this.popperRef.current;
      var anchor = _this.anchorRef.current; // Ignore document click if it came from popover or anchor

      if (!popper || popper === target || popper.contains(target)) {
        return;
      }

      if (!anchor || anchor === target || anchor.contains(target)) {
        return;
      }

      if (_this.props.onClickOutside) {
        _this.props.onClickOutside(evt);
      }
    });

    return _this;
  }

  _createClass(PopoverInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.init(prevProps, prevState);

      if (this.props.autoFocus && this.props.focusLock && !this.state.autoFocusAfterPositioning && this.popperRef.current !== null && this.popperRef.current.getBoundingClientRect().top > 0) {
        this.setState({
          autoFocusAfterPositioning: true
        });
      }

      if (false) {}
    }
  }, {
    key: "init",
    value: function init(prevProps, prevState) {
      if (this.props.isOpen !== prevProps.isOpen || this.state.isMounted !== prevState.isMounted || this.state.isLayerMounted !== prevState.isLayerMounted) {
        // Transition from closed to open.
        if (this.props.isOpen && this.state.isLayerMounted) {
          // Clear any existing timers (like previous animateOutCompleteTimer)
          this.clearTimers();
          return;
        } // Transition from open to closed.


        if (!this.props.isOpen && prevProps.isOpen) {
          this.animateOutTimer = setTimeout(this.animateOut, 20);
          return;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimers();
    }
  }, {
    key: "getDefaultState",
    value: function getDefaultState(props) {
      return {
        isAnimating: false,
        arrowOffset: {
          left: 0,
          top: 0
        },
        popoverOffset: {
          left: 0,
          top: 0
        },
        placement: props.placement,
        isMounted: false,
        isLayerMounted: false,
        autoFocusAfterPositioning: false
      };
    }
  }, {
    key: "clearTimers",
    value: function clearTimers() {
      [this.animateInTimer, this.animateOutTimer, this.animateOutCompleteTimer, this.onMouseEnterTimer, this.onMouseLeaveTimer].forEach(function (timerId) {
        if (timerId) {
          clearTimeout(timerId);
        }
      });
    }
  }, {
    key: "triggerOnMouseLeaveWithDelay",
    value: function triggerOnMouseLeaveWithDelay(e) {
      var _this2 = this;

      var onMouseLeaveDelay = this.props.onMouseLeaveDelay;

      if (onMouseLeaveDelay) {
        this.onMouseLeaveTimer = setTimeout(function () {
          return _this2.triggerOnMouseLeave(e);
        }, onMouseLeaveDelay);
        return;
      }

      this.triggerOnMouseLeave(e);
    }
  }, {
    key: "triggerOnMouseEnterWithDelay",
    value: function triggerOnMouseEnterWithDelay(e) {
      var _this3 = this;

      var onMouseEnterDelay = this.props.onMouseEnterDelay;

      if (onMouseEnterDelay) {
        this.onMouseEnterTimer = setTimeout(function () {
          return _this3.triggerOnMouseEnter(e);
        }, onMouseEnterDelay);
        return;
      }

      this.triggerOnMouseEnter(e);
    }
  }, {
    key: "isClickTrigger",
    value: function isClickTrigger() {
      return this.props.triggerType === constants/* TRIGGER_TYPE */.gu.click;
    }
  }, {
    key: "isHoverTrigger",
    value: function isHoverTrigger() {
      return this.props.triggerType === constants/* TRIGGER_TYPE */.gu.hover;
    }
  }, {
    key: "isAccessibilityTypeMenu",
    value: function isAccessibilityTypeMenu() {
      return this.props.accessibilityType === constants/* ACCESSIBILITY_TYPE */.SI.menu;
    }
  }, {
    key: "isAccessibilityTypeTooltip",
    value: function isAccessibilityTypeTooltip() {
      return this.props.accessibilityType === constants/* ACCESSIBILITY_TYPE */.SI.tooltip;
    }
  }, {
    key: "getAnchorIdAttr",
    value: function getAnchorIdAttr() {
      var popoverId = this.getPopoverIdAttr();
      return popoverId ? "".concat(popoverId, "__anchor") : null;
    }
  }, {
    key: "getPopoverIdAttr",
    value: function getPopoverIdAttr() {
      return this.props.id || null;
    }
  }, {
    key: "getAnchorProps",
    value: function getAnchorProps() {
      var isOpen = this.props.isOpen;
      var anchorProps = {
        'aria-haspopup': 'true',
        'aria-expanded': isOpen ? 'true' : 'false',
        key: 'popover-anchor',
        ref: this.anchorRef
      };
      var popoverId = this.getPopoverIdAttr();

      if (this.isAccessibilityTypeMenu()) {
        var relationAttr = this.isClickTrigger() ? 'aria-controls' : 'aria-owns';
        anchorProps[relationAttr] = isOpen ? popoverId : null;
      } else if (this.isAccessibilityTypeTooltip()) {
        anchorProps.id = this.getAnchorIdAttr();
        anchorProps['aria-describedby'] = isOpen ? popoverId : null;
      }

      if (this.isHoverTrigger()) {
        anchorProps.onMouseEnter = this.onAnchorMouseEnter;
        anchorProps.onMouseLeave = this.onAnchorMouseLeave; // Make it focusable too

        anchorProps.onBlur = this.props.onBlur;
        anchorProps.onFocus = this.props.onFocus;
      } else {
        anchorProps.onClick = this.onAnchorClick;
      }

      return anchorProps;
    }
  }, {
    key: "getPopoverBodyProps",
    value: function getPopoverBodyProps() {
      var bodyProps = {};
      var popoverId = this.getPopoverIdAttr();

      if (this.isAccessibilityTypeMenu()) {
        bodyProps.id = popoverId;
      } else if (this.isAccessibilityTypeTooltip()) {
        bodyProps.id = popoverId;
        bodyProps.role = 'tooltip';
      }

      if (this.isHoverTrigger()) {
        bodyProps.onMouseEnter = this.onPopoverMouseEnter;
        bodyProps.onMouseLeave = this.onPopoverMouseLeave;
      }

      return bodyProps;
    }
  }, {
    key: "getSharedProps",
    value: function getSharedProps() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          showArrow = _this$props.showArrow,
          _this$props$popoverMa = _this$props.popoverMargin,
          popoverMargin = _this$props$popoverMa === void 0 ? constants/* POPOVER_MARGIN */.AF : _this$props$popoverMa;
      var _this$state = this.state,
          isAnimating = _this$state.isAnimating,
          arrowOffset = _this$state.arrowOffset,
          popoverOffset = _this$state.popoverOffset,
          placement = _this$state.placement;
      return {
        $showArrow: !!showArrow,
        $arrowOffset: arrowOffset,
        $popoverOffset: popoverOffset,
        $placement: placement,
        $isAnimating: isAnimating,
        $isOpen: isOpen,
        $popoverMargin: popoverMargin,
        $isHoverTrigger: this.isHoverTrigger()
      };
    }
  }, {
    key: "getAnchorFromChildren",
    value: function getAnchorFromChildren() {
      var children = this.props.children;
      var childArray = react.Children.toArray(children);

      if (childArray.length !== 1) {
        // eslint-disable-next-line no-console
        console.error("[baseui] Exactly 1 child must be passed to Popover/Tooltip, found ".concat(childArray.length, " children"));
      }

      return childArray[0];
    }
  }, {
    key: "renderAnchor",
    value: function renderAnchor() {
      var anchor = this.getAnchorFromChildren();

      if (!anchor) {
        return null;
      }

      var isValidElement = /*#__PURE__*/react.isValidElement(anchor);
      var anchorProps = this.getAnchorProps();

      if (_typeof(anchor) === 'object' && isValidElement) {
        return /*#__PURE__*/react.cloneElement(anchor, anchorProps);
      }

      return /*#__PURE__*/react.createElement("span", anchorProps, anchor);
    }
  }, {
    key: "renderPopover",
    value: function renderPopover(renderedContent) {
      var _this$props2 = this.props,
          showArrow = _this$props2.showArrow,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override;
      var ArrowOverride = overrides.Arrow,
          BodyOverride = overrides.Body,
          InnerOverride = overrides.Inner;
      var Arrow = (0,helpers_overrides/* getOverride */.XG)(ArrowOverride) || styled_components/* Arrow */.Eh;
      var Body = (0,helpers_overrides/* getOverride */.XG)(BodyOverride) || styled_components/* Body */.uT;
      var Inner = (0,helpers_overrides/* getOverride */.XG)(InnerOverride) || styled_components/* Inner */.Nh;
      var sharedProps = this.getSharedProps();
      var bodyProps = this.getPopoverBodyProps();
      return /*#__PURE__*/react.createElement(Body, _extends({
        key: "popover-body",
        ref: this.popperRef,
        "data-baseweb": this.props['data-baseweb'] || 'popover'
      }, bodyProps, sharedProps, (0,helpers_overrides/* getOverrideProps */.ch)(BodyOverride)), showArrow ? /*#__PURE__*/react.createElement(Arrow, _extends({
        key: "popover-arrow",
        ref: this.arrowRef
      }, sharedProps, (0,helpers_overrides/* getOverrideProps */.ch)(ArrowOverride))) : null, /*#__PURE__*/react.createElement(Inner, _extends({}, sharedProps, (0,helpers_overrides/* getOverrideProps */.ch)(InnerOverride)), renderedContent));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var content = this.props.content;
      return typeof content === 'function' ? content() : content;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var mountedAndOpen = this.state.isMounted && this.props.isOpen;
      var rendered = [this.renderAnchor()];
      var renderedContent = mountedAndOpen || this.props.renderAll ? this.renderContent() : null;
      var defaultPopperOptions = {
        modifiers: {
          preventOverflow: {
            enabled: !this.props.ignoreBoundary,
            padding: 0
          }
        }
      }; // Only render popover on the browser (portals aren't supported server-side)

      if (renderedContent) {
        if (mountedAndOpen) {
          rendered.push( /*#__PURE__*/react.createElement(layer_layer/* default */.Z, {
            key: "new-layer",
            mountNode: this.props.mountNode,
            onEscape: this.props.onEsc,
            onDocumentClick: this.isHoverTrigger() ? undefined : this.onDocumentClick,
            isHoverLayer: this.isHoverTrigger(),
            onMount: function onMount() {
              return _this4.setState({
                isLayerMounted: true
              });
            },
            onUnmount: function onUnmount() {
              return _this4.setState({
                isLayerMounted: false
              });
            }
          }, /*#__PURE__*/react.createElement(tether/* default */.Z, {
            anchorRef: this.anchorRef.current,
            arrowRef: this.arrowRef.current,
            popperRef: this.popperRef.current // Remove the `ignoreBoundary` prop in the next major version
            // and have it replaced with the TetherBehavior props overrides
            ,
            popperOptions: _objectSpread(_objectSpread({}, defaultPopperOptions), this.props.popperOptions),
            onPopperUpdate: this.onPopperUpdate,
            placement: this.state.placement
          }, /*#__PURE__*/react.createElement(es2015/* default */.ZP, {
            disabled: !this.props.focusLock,
            noFocusGuards: false // see popover-focus-loop.scenario.js for why hover cannot return focus
            ,
            returnFocus: this.props.returnFocus && !this.isHoverTrigger(),
            autoFocus: this.state.autoFocusAfterPositioning
          }, this.renderPopover(renderedContent)))));
        } else {
          rendered.push( /*#__PURE__*/react.createElement(styled_components/* Hidden */._G, {
            key: "hidden-layer"
          }, renderedContent));
        }
      }

      return rendered;
    }
  }]);

  return PopoverInner;
}(react.Component); // Remove when Popover is converted to a functional component.


_defineProperty(PopoverInner, "defaultProps", default_props);

var Popover = function Popover(props) {
  var innerRef = props.innerRef;
  return /*#__PURE__*/react.createElement(PopoverInner, _extends({
    id: props.id || (0,hooks/* useUID */.D)(),
    ref: innerRef
  }, props));
};

Popover.defaultProps = default_props;
/* harmony default export */ const popover = (Popover);
/* eslint-enable react/no-find-dom-node */

/***/ }),

/***/ 72421:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Eh: () => (/* binding */ Arrow),
/* harmony export */   N4: () => (/* binding */ getArrowStyles),
/* harmony export */   Nh: () => (/* binding */ Inner),
/* harmony export */   _G: () => (/* binding */ Hidden),
/* harmony export */   "do": () => (/* binding */ getInnerStyles),
/* harmony export */   mg: () => (/* binding */ getBodyStyles),
/* harmony export */   uT: () => (/* binding */ Body)
/* harmony export */ });
/* unused harmony export Padding */
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10334);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64165);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43875);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/




/**
 * Main popover container element that gets positioned next to the anchor
 */
function getBodyStyles(props) {
  var $isOpen = props.$isOpen,
      $isAnimating = props.$isAnimating,
      $placement = props.$placement,
      $popoverOffset = props.$popoverOffset,
      $showArrow = props.$showArrow,
      $theme = props.$theme,
      $popoverMargin = props.$popoverMargin,
      $isHoverTrigger = props.$isHoverTrigger;
  return _objectSpread(_objectSpread({
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: $theme.colors.backgroundTertiary,
    borderTopLeftRadius: $theme.borders.popoverBorderRadius,
    borderTopRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomLeftRadius: $theme.borders.popoverBorderRadius,
    boxShadow: $theme.lighting.shadow600,
    transitionProperty: 'opacity,transform',
    transitionDuration: $isAnimating ? '0.1s' : '0s',
    transitionTimingFunction: $isOpen ? $theme.animation.easeOutCurve : $theme.animation.easeInCurve,
    opacity: $isAnimating && $isOpen ? 1 : 0,
    transform: $isAnimating && $isOpen ? (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .getEndPosition */ .G1)($popoverOffset) : (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .getStartPosition */ .nr)($popoverOffset, $placement, $showArrow ? _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ARROW_SIZE */ .YM : 0, $popoverMargin)
  }, (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .getPopoverMarginStyles */ .PQ)($showArrow ? _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ARROW_SIZE */ .YM : 0, $placement, $popoverMargin)), $isHoverTrigger ? {
    animationDuration: '.1s',
    animationName: {
      '0%': {
        pointerEvents: 'none'
      },
      '99%': {
        pointerEvents: 'none'
      },
      '100%': {
        pointerEvents: 'auto'
      }
    }
  } : {});
}
var Body = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)('div', getBodyStyles);
/**
 * Arrow shown between the popover and the anchor element
 */

Body.displayName = "Body";
function getArrowStyles(props) {
  var $arrowOffset = props.$arrowOffset,
      $placement = props.$placement,
      $theme = props.$theme;
  return _objectSpread({
    backgroundColor: $theme.colors.backgroundTertiary,
    boxShadow: $theme.lighting.shadow600,
    width: "".concat(_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ARROW_WIDTH */ .mb, "px"),
    height: "".concat(_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ARROW_WIDTH */ .mb, "px"),
    transform: 'rotate(45deg)',
    position: 'absolute'
  }, (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .getArrowPositionStyles */ .wL)($arrowOffset, $placement));
}
var Arrow = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)('div', getArrowStyles);
/**
 * Extra div that holds the popover content. This extra element
 * is needed for the arrow–the arrow is just a 45deg rotated div,
 * and rendering this extra element on top with a solid background
 * clips the part of the arrow that extends into the popover.
 */

Arrow.displayName = "Arrow";
function getInnerStyles(_ref) {
  var $theme = _ref.$theme;
  return {
    backgroundColor: $theme.colors.backgroundTertiary,
    borderTopLeftRadius: $theme.borders.popoverBorderRadius,
    borderTopRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomLeftRadius: $theme.borders.popoverBorderRadius,
    color: $theme.colors.contentPrimary,
    position: 'relative'
  };
}
var Inner = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)('div', getInnerStyles);
/**
 * A drop-in component that provides the recommended padding
 * for popovers. Mostly a convenience for users so they don't
 * have to define this themselves.
 */

Inner.displayName = "Inner";
var Padding = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)('div', {
  paddingLeft: '12px',
  paddingTop: '12px',
  paddingRight: '12px',
  paddingBottom: '12px'
});
Padding.displayName = "Padding";
var Hidden = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)('div', {
  display: 'none'
});
Hidden.displayName = "Hidden";

/***/ }),

/***/ 43875:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G1: () => (/* binding */ getEndPosition),
/* harmony export */   PQ: () => (/* binding */ getPopoverMarginStyles),
/* harmony export */   PR: () => (/* binding */ fromPopperPlacement),
/* harmony export */   nr: () => (/* binding */ getStartPosition),
/* harmony export */   wL: () => (/* binding */ getArrowPositionStyles)
/* harmony export */ });
/* unused harmony exports getOppositePosition, isVerticalPosition, capitalize, splitPlacement */
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64165);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable import/prefer-default-export */

var OPPOSITE_POSITIONS = {
  top: 'bottom',
  bottom: 'top',
  right: 'left',
  left: 'right'
};
/**
 * Returns the opposite of the specified position. Useful for tooltip
 * positioning logic.
 * Examples:
 * top -> bottom
 * left -> right
 */

function getOppositePosition(position) {
  return OPPOSITE_POSITIONS[position];
}
/**
 * Determines whether or not the specified position is a vertical one (top or bottom)
 */

function isVerticalPosition(position) {
  return position === 'top' || position === 'bottom';
}
/**
 * Simple utility function for capitalizing the first letter of a string
 */

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * Opposite of function above, converts from Popper.js placement
 * to our placement prop
 */

function fromPopperPlacement(placement) {
  var popoverPlacement = placement.replace(/(top|bottom)-start$/, '$1Left').replace(/(top|bottom)-end$/, '$1Right').replace(/(left|right)-start$/, '$1Top').replace(/(left|right)-end$/, '$1Bottom');
  return _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .PLACEMENT */ .r4[popoverPlacement] || null;
}
/**
 * Splits something like 'topLeft' to ['top', 'left'] for easier usage
 */

function splitPlacement(placement) {
  var matches = placement.match(/^([a-z]+)([A-Z][a-z]+)?/) || [];
  return matches.slice(1, 3).filter(Boolean).map(function (s) {
    return s.toLowerCase();
  });
}
/**
 * Returns margin styles to add spacing between the popover
 * and its anchor.
 */

function getPopoverMarginStyles(arrowSize, placement, popoverMargin) {
  var _splitPlacement = splitPlacement(placement),
      _splitPlacement2 = _slicedToArray(_splitPlacement, 1),
      position = _splitPlacement2[0];

  var opposite = getOppositePosition(position);

  if (!opposite) {
    return null;
  }

  var property = "margin".concat(capitalize(opposite));
  return _defineProperty({}, property, "".concat(arrowSize + popoverMargin, "px"));
}
/**
 * Returns CSS rules for the popover animation start keyframe
 */

function getStartPosition(offset, placement, arrowSize, popoverMargin) {
  offset = _objectSpread({}, offset);

  var _splitPlacement3 = splitPlacement(placement),
      _splitPlacement4 = _slicedToArray(_splitPlacement3, 1),
      position = _splitPlacement4[0];

  var margin = (arrowSize > 0 ? arrowSize : popoverMargin) * 2;

  if (isVerticalPosition(position)) {
    offset.top += position === 'top' ? margin : -margin;
  } else {
    offset.left += position === 'left' ? margin : -margin;
  }

  return "translate3d(".concat(offset.left, "px, ").concat(offset.top, "px, 0)");
}
/**
 * Returns CSS rules for the popover animation end keyframe
 */

function getEndPosition(offset) {
  return "translate3d(".concat(offset.left, "px, ").concat(offset.top, "px, 0)");
}
/**
 * Returns top/left styles to position the popover arrow
 */

function getArrowPositionStyles(offsets, placement) {
  var _ref2;

  var _splitPlacement5 = splitPlacement(placement),
      _splitPlacement6 = _slicedToArray(_splitPlacement5, 1),
      position = _splitPlacement6[0];

  var oppositePosition = getOppositePosition(position);

  if (!oppositePosition) {
    return null;
  }

  var alignmentProperty = isVerticalPosition(position) ? 'left' : 'top';
  return _ref2 = {}, _defineProperty(_ref2, alignmentProperty, "".concat(offsets[alignmentProperty], "px")), _defineProperty(_ref2, oppositePosition, "-".concat(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .ARROW_SIZE */ .YM - 2, "px")), _ref2;
}

/***/ }),

/***/ 10334:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Le: () => (/* binding */ withWrapper),
/* harmony export */   hQ: () => (/* binding */ useStyletron),
/* harmony export */   w1: () => (/* binding */ withStyle),
/* harmony export */   zo: () => (/* binding */ styled)
/* harmony export */ });
/* unused harmony exports createThemedStyled, createThemedWithStyle, createThemedUseStyletron */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81262);
/* harmony import */ var styletron_standard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98351);
/* harmony import */ var _theme_provider_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55468);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/





var wrapper = function wrapper(StyledComponent) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_theme_provider_js__WEBPACK_IMPORTED_MODULE_1__/* .ThemeContext */ .N.Consumer, null, function (theme) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledComponent, _extends({
        ref: ref
      }, props, {
        $theme: theme
      }));
    });
  });
};
/* eslint-disable flowtype/generic-spacing */

/* eslint-disable flowtype/no-weak-types */


/* eslint-enable flowtype/generic-spacing */

/* eslint-enable flowtype/no-weak-types */
function createThemedStyled() {
  return (0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .createStyled */ .Se)({
    wrapper: wrapper,
    getInitialStyle: styletron_standard__WEBPACK_IMPORTED_MODULE_3__/* .getInitialStyle */ .r4,
    driver: styletron_standard__WEBPACK_IMPORTED_MODULE_3__/* .driver */ .vC // eslint-disable-next-line flowtype/no-weak-types

  });
}
var styled = createThemedStyled();
function createThemedWithStyle() {
  // eslint-disable-next-line flowtype/no-weak-types
  return styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .withStyle */ .w1;
}
var withStyle = createThemedWithStyle();
function createThemedUseStyletron() {
  return function () {
    // eslint-disable-next-line flowtype/no-weak-types
    var theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_theme_provider_js__WEBPACK_IMPORTED_MODULE_1__/* .ThemeContext */ .N);

    var _styletronUseStyletro = (0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)(),
        _styletronUseStyletro2 = _slicedToArray(_styletronUseStyletro, 1),
        css = _styletronUseStyletro2[0];

    return [css, theme];
  };
}
var useStyletron = createThemedUseStyletron();
function withWrapper( // eslint-disable-next-line flowtype/no-weak-types
StyledElement, wrapperFn) {
  // eslint-disable-next-line flowtype/no-weak-types
  return (0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .withWrapper */ .Le)(StyledElement, function (Styled) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_theme_provider_js__WEBPACK_IMPORTED_MODULE_1__/* .ThemeContext */ .N.Consumer, null, function (theme) {
        return wrapperFn(Styled)(_objectSpread(_objectSpread({
          ref: ref
        }, props), {}, {
          $theme: theme
        }));
      });
    });
  });
}

/***/ }),

/***/ 55468:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  N: () => (/* binding */ ThemeContext),
  Z: () => (/* binding */ theme_provider)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/color-tokens.js
var color_tokens = __webpack_require__(43258);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/color-semantic-tokens.js
var color_semantic_tokens = __webpack_require__(80217);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/color-component-tokens.js
var color_component_tokens = __webpack_require__(43579);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/color-deprecated-semantic-tokens.js
var color_deprecated_semantic_tokens = __webpack_require__(10482);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/borders.js
var borders = __webpack_require__(23112);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/lighting.js
var lighting = __webpack_require__(63131);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/typography.js
var typography = __webpack_require__(86081);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/animation.js
var animation = __webpack_require__(30889);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/breakpoints.js
var breakpoints = __webpack_require__(1687);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/grid.js
var grid = __webpack_require__(67755);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/media-query.js
var media_query = __webpack_require__(84025);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/sizing.js
var sizing = __webpack_require__(57049);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/light-theme.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/












var LightTheme = {
  name: 'light-theme',
  colors: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, color_tokens/* default */.Z), (0,color_component_tokens/* default */.Z)()), (0,color_deprecated_semantic_tokens/* default */.Z)()), (0,color_semantic_tokens/* default */.Z)()),
  animation: animation/* default */.Z,
  breakpoints: breakpoints/* default */.Z,
  borders: borders/* default */.Z,
  direction: 'auto',
  grid: grid/* default */.Z,
  lighting: lighting/* default */.Z,
  mediaQuery: media_query/* default */.Z,
  sizing: sizing/* default */.Z,
  typography: (0,typography/* default */.Z)(),
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2000
  }
};
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/theme-provider.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


var ThemeContext = /*#__PURE__*/react.createContext(LightTheme);

var ThemeProvider = function ThemeProvider(props) {
  var theme = props.theme,
      children = props.children;
  return /*#__PURE__*/react.createElement(ThemeContext.Provider, {
    value: theme
  }, children);
};

/* harmony default export */ const theme_provider = (ThemeProvider);

/***/ }),

/***/ 9471:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Qj: () => (/* binding */ expandBorderStyles),
/* harmony export */   oo: () => (/* binding */ hexToRgb),
/* harmony export */   wj: () => (/* binding */ ellipsisText)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function hexToRgb() {
  var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1';
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? "rgba(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ", ").concat(alpha, ")") : null;
}
var ellipsisText = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordWrap: 'normal'
};
function expandBorderStyles(borderStyles) {
  return {
    borderTopWidth: borderStyles.borderWidth,
    borderTopStyle: borderStyles.borderStyle,
    borderTopColor: borderStyles.borderColor,
    borderBottomWidth: borderStyles.borderWidth,
    borderBottomStyle: borderStyles.borderStyle,
    borderBottomColor: borderStyles.borderColor,
    borderLeftWidth: borderStyles.borderWidth,
    borderLeftStyle: borderStyles.borderStyle,
    borderLeftColor: borderStyles.borderColor,
    borderRightWidth: borderStyles.borderWidth,
    borderRightStyle: borderStyles.borderStyle,
    borderRightColor: borderStyles.borderColor
  };
}

/***/ }),

/***/ 43579:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43258);
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var tagHoverBackground = "rgba(0, 0, 0, 0.08)";
/* ---- Component colors ---- */
// TODO(#2318) Make it a plain object in the next v11 major version
// with values taken from `colorTokens`.
// Due to the legacy `createTheme` type the value need to be
// overrideable through primitives (`foundation` )

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
  return {
    // Buttons
    buttonPrimaryFill: themePrimitives.primary,
    buttonPrimaryText: themePrimitives.white,
    buttonPrimaryHover: themePrimitives.primary700,
    buttonPrimaryActive: themePrimitives.primary600,
    buttonPrimarySelectedFill: themePrimitives.primary600,
    buttonPrimarySelectedText: themePrimitives.white,
    buttonPrimarySpinnerForeground: themePrimitives.primary50,
    buttonPrimarySpinnerBackground: themePrimitives.primary500,
    buttonSecondaryFill: themePrimitives.primary100,
    buttonSecondaryText: themePrimitives.primary,
    buttonSecondaryHover: themePrimitives.primary200,
    buttonSecondaryActive: themePrimitives.primary300,
    buttonSecondarySelectedFill: themePrimitives.primary300,
    buttonSecondarySelectedText: themePrimitives.primary,
    buttonSecondarySpinnerForeground: themePrimitives.primary700,
    buttonSecondarySpinnerBackground: themePrimitives.primary300,
    buttonTertiaryFill: 'transparent',
    buttonTertiaryText: themePrimitives.primary,
    buttonTertiaryHover: themePrimitives.primary50,
    buttonTertiaryActive: themePrimitives.primary100,
    buttonTertiarySelectedFill: themePrimitives.primary100,
    buttonTertiarySelectedText: themePrimitives.primary,
    buttonTertiarySpinnerForeground: themePrimitives.primary700,
    buttonTertiarySpinnerBackground: themePrimitives.primary300,
    buttonMinimalFill: 'transparent',
    buttonMinimalText: themePrimitives.primary,
    buttonMinimalHover: themePrimitives.primary50,
    buttonMinimalActive: themePrimitives.primary100,
    buttonMinimalSelectedFill: themePrimitives.primary100,
    buttonMinimalSelectedText: themePrimitives.primary,
    buttonMinimalSpinnerForeground: themePrimitives.primary700,
    buttonMinimalSpinnerBackground: themePrimitives.primary300,
    buttonDisabledFill: themePrimitives.mono200,
    buttonDisabledText: themePrimitives.mono600,
    buttonDisabledSpinnerForeground: themePrimitives.mono600,
    buttonDisabledSpinnerBackground: themePrimitives.mono400,
    // Breadcrumbs
    breadcrumbsText: themePrimitives.mono900,
    breadcrumbsSeparatorFill: themePrimitives.mono700,
    // Datepicker
    datepickerBackground: themePrimitives.mono100,
    datepickerDayFont: themePrimitives.mono1000,
    datepickerDayFontDisabled: themePrimitives.mono500,
    datepickerDayPseudoSelected: themePrimitives.primary100,
    datepickerDayPseudoHighlighted: themePrimitives.primary200,
    // Calendar
    calendarBackground: themePrimitives.mono100,
    calendarForeground: themePrimitives.mono1000,
    calendarForegroundDisabled: themePrimitives.mono500,
    calendarHeaderBackground: themePrimitives.white,
    calendarHeaderForeground: themePrimitives.primary,
    calendarHeaderBackgroundActive: themePrimitives.primary700,
    calendarHeaderForegroundDisabled: themePrimitives.primary500,
    calendarDayBackgroundPseudoSelected: themePrimitives.primary100,
    calendarDayForegroundPseudoSelected: themePrimitives.mono1000,
    calendarDayBackgroundPseudoSelectedHighlighted: themePrimitives.primary200,
    calendarDayForegroundPseudoSelectedHighlighted: themePrimitives.mono1000,
    calendarDayBackgroundSelected: themePrimitives.primary,
    calendarDayForegroundSelected: themePrimitives.white,
    calendarDayBackgroundSelectedHighlighted: themePrimitives.primary,
    calendarDayForegroundSelectedHighlighted: themePrimitives.white,
    // Combobox
    comboboxListItemFocus: themePrimitives.mono200,
    comboboxListItemHover: themePrimitives.mono300,
    // FileUploader
    fileUploaderBackgroundColor: themePrimitives.mono200,
    fileUploaderBackgroundColorActive: themePrimitives.primary50,
    fileUploaderBorderColorActive: themePrimitives.primary,
    fileUploaderBorderColorDefault: themePrimitives.mono500,
    fileUploaderMessageColor: themePrimitives.mono800,
    // Links
    linkText: themePrimitives.primary,
    linkVisited: themePrimitives.primary700,
    linkHover: themePrimitives.primary600,
    linkActive: themePrimitives.primary500,
    // List
    listHeaderFill: themePrimitives.white,
    listBodyFill: themePrimitives.mono200,
    listIconFill: themePrimitives.mono500,
    listBorder: themePrimitives.mono500,
    // ProgressSteps
    progressStepsCompletedText: themePrimitives.white,
    progressStepsCompletedFill: themePrimitives.primary,
    progressStepsActiveText: themePrimitives.white,
    progressStepsActiveFill: themePrimitives.primary,
    progressStepsIconActiveFill: themePrimitives.primary,
    // Toggle
    toggleFill: themePrimitives.white,
    toggleFillChecked: themePrimitives.primary,
    toggleFillDisabled: themePrimitives.mono600,
    toggleTrackFill: themePrimitives.mono400,
    toggleTrackFillDisabled: themePrimitives.mono300,
    // Tick
    tickFill: themePrimitives.mono100,
    tickFillHover: themePrimitives.mono200,
    tickFillActive: themePrimitives.mono300,
    tickFillSelected: themePrimitives.primary,
    tickFillSelectedHover: themePrimitives.primary700,
    tickFillSelectedHoverActive: themePrimitives.primary600,
    tickFillError: themePrimitives.negative50,
    tickFillErrorHover: themePrimitives.negative100,
    tickFillErrorHoverActive: themePrimitives.negative200,
    tickFillErrorSelected: themePrimitives.negative400,
    tickFillErrorSelectedHover: themePrimitives.negative500,
    tickFillErrorSelectedHoverActive: themePrimitives.negative600,
    tickFillDisabled: themePrimitives.mono600,
    tickBorder: themePrimitives.mono700,
    tickBorderError: themePrimitives.negative400,
    tickMarkFill: themePrimitives.white,
    tickMarkFillError: themePrimitives.white,
    tickMarkFillDisabled: themePrimitives.mono100,
    // Slider/Toggle
    sliderTrackFill: 'transparent',
    sliderHandleFill: themePrimitives.primaryA,
    sliderHandleFillDisabled: themePrimitives.primary400,
    sliderHandleInnerFill: themePrimitives.primaryA,
    sliderTrackFillHover: themePrimitives.mono500,
    sliderTrackFillActive: themePrimitives.mono600,
    sliderTrackFillSelected: themePrimitives.primary,
    sliderTrackFillSelectedHover: themePrimitives.primary,
    sliderTrackFillSelectedActive: themePrimitives.primary500,
    sliderTrackFillDisabled: themePrimitives.mono300,
    sliderHandleFillHover: themePrimitives.white,
    sliderHandleFillActive: themePrimitives.white,
    sliderHandleFillSelected: themePrimitives.white,
    sliderHandleFillSelectedHover: themePrimitives.white,
    sliderHandleFillSelectedActive: themePrimitives.white,
    sliderHandleInnerFillDisabled: themePrimitives.mono400,
    sliderHandleInnerFillSelectedHover: themePrimitives.primary,
    sliderHandleInnerFillSelectedActive: themePrimitives.primary500,
    sliderBorder: themePrimitives.mono500,
    sliderBorderHover: themePrimitives.primary,
    sliderBorderDisabled: themePrimitives.mono600,
    // Inputs
    inputBorder: themePrimitives.mono300,
    inputFill: themePrimitives.mono300,
    inputFillError: themePrimitives.negative50,
    inputFillDisabled: themePrimitives.mono200,
    inputFillActive: themePrimitives.mono200,
    inputFillPositive: themePrimitives.positive50,
    inputTextDisabled: themePrimitives.mono600,
    inputBorderError: themePrimitives.negative200,
    inputBorderPositive: themePrimitives.positive200,
    inputEnhancerFill: themePrimitives.mono300,
    inputEnhancerFillDisabled: themePrimitives.mono300,
    inputEnhancerTextDisabled: themePrimitives.mono600,
    inputPlaceholder: themePrimitives.mono700,
    inputPlaceholderDisabled: themePrimitives.mono600,
    // Menu
    menuFill: themePrimitives.mono100,
    menuFillHover: themePrimitives.mono200,
    menuFontDefault: themePrimitives.mono800,
    menuFontDisabled: themePrimitives.mono500,
    menuFontHighlighted: themePrimitives.mono1000,
    menuFontSelected: themePrimitives.mono1000,
    // Modal
    modalCloseColor: themePrimitives.mono1000,
    modalCloseColorHover: themePrimitives.mono800,
    modalCloseColorFocus: themePrimitives.mono800,
    // Pagination
    paginationTriangleDown: themePrimitives.mono800,
    // Header navigation
    headerNavigationFill: 'transparent',
    // Tab
    tabBarFill: themePrimitives.mono200,
    tabColor: themePrimitives.mono800,
    // Notification
    notificationPrimaryBackground: themePrimitives.primary50,
    notificationPrimaryText: themePrimitives.primary500,
    notificationInfoBackground: themePrimitives.accent50,
    notificationInfoText: themePrimitives.accent500,
    notificationPositiveBackground: themePrimitives.positive50,
    notificationPositiveText: themePrimitives.positive500,
    notificationWarningBackground: themePrimitives.warning50,
    notificationWarningText: themePrimitives.warning500,
    notificationNegativeBackground: themePrimitives.negative50,
    notificationNegativeText: themePrimitives.negative500,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: '100',
    tagOutlinedDisabledRampUnit: '200',
    tagSolidFontRampUnit: '0',
    tagSolidRampUnit: '400',
    tagOutlinedFontRampUnit: '400',
    tagOutlinedRampUnit: '200',
    // Deprecated
    tagSolidHoverRampUnit: '50',
    tagSolidActiveRampUnit: '100',
    tagSolidDisabledRampUnit: '50',
    tagSolidFontHoverRampUnit: '500',
    tagLightRampUnit: '50',
    tagLightHoverRampUnit: '100',
    tagLightActiveRampUnit: '100',
    tagLightDisabledRampUnit: '50',
    tagLightFontRampUnit: '500',
    tagLightFontHoverRampUnit: '500',
    tagOutlinedHoverRampUnit: '50',
    tagOutlinedActiveRampUnit: '0',
    tagOutlinedFontHoverRampUnit: '400',
    // Neutral
    tagNeutralFontDisabled: themePrimitives.mono600,
    tagNeutralOutlinedDisabled: themePrimitives.mono400,
    tagNeutralSolidFont: themePrimitives.white,
    tagNeutralSolidBackground: themePrimitives.black,
    tagNeutralOutlinedBackground: themePrimitives.mono600,
    tagNeutralOutlinedFont: themePrimitives.black,
    // Deprecated
    tagNeutralSolidHover: themePrimitives.mono300,
    tagNeutralSolidActive: themePrimitives.mono400,
    tagNeutralSolidDisabled: themePrimitives.mono200,
    tagNeutralSolidFontHover: themePrimitives.mono900,
    tagNeutralLightBackground: themePrimitives.mono300,
    tagNeutralLightHover: themePrimitives.mono300,
    tagNeutralLightActive: themePrimitives.mono400,
    tagNeutralLightDisabled: themePrimitives.mono200,
    tagNeutralLightFont: themePrimitives.mono900,
    tagNeutralLightFontHover: themePrimitives.mono900,
    tagNeutralOutlinedActive: themePrimitives.mono900,
    tagNeutralOutlinedFontHover: themePrimitives.mono800,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryFontDisabled: themePrimitives.primary400,
    tagPrimaryOutlinedDisabled: themePrimitives.primary200,
    tagPrimarySolidFont: themePrimitives.white,
    tagPrimarySolidBackground: themePrimitives.primary,
    tagPrimaryOutlinedFontHover: themePrimitives.primary,
    tagPrimaryOutlinedFont: themePrimitives.primary,
    // Deprecated
    tagPrimarySolidHover: themePrimitives.primary100,
    tagPrimarySolidActive: themePrimitives.primary200,
    tagPrimarySolidDisabled: themePrimitives.primary50,
    tagPrimarySolidFontHover: themePrimitives.primary700,
    tagPrimaryLightBackground: themePrimitives.primary50,
    tagPrimaryLightHover: themePrimitives.primary100,
    tagPrimaryLightActive: themePrimitives.primary100,
    tagPrimaryLightDisabled: themePrimitives.primary50,
    tagPrimaryLightFont: themePrimitives.primary500,
    tagPrimaryLightFontHover: themePrimitives.primary500,
    tagPrimaryOutlinedActive: themePrimitives.primary600,
    tagPrimaryOutlinedHover: tagHoverBackground,
    tagPrimaryOutlinedBackground: themePrimitives.primary400,
    // Accent
    tagAccentFontDisabled: themePrimitives.accent200,
    tagAccentOutlinedDisabled: themePrimitives.accent200,
    tagAccentSolidFont: themePrimitives.white,
    tagAccentSolidBackground: themePrimitives.accent400,
    tagAccentOutlinedBackground: themePrimitives.accent200,
    tagAccentOutlinedFont: themePrimitives.accent400,
    // Deprecated
    tagAccentSolidHover: themePrimitives.accent50,
    tagAccentSolidActive: themePrimitives.accent100,
    tagAccentSolidDisabled: themePrimitives.accent50,
    tagAccentSolidFontHover: themePrimitives.accent500,
    tagAccentLightBackground: themePrimitives.accent50,
    tagAccentLightHover: themePrimitives.accent100,
    tagAccentLightActive: themePrimitives.accent100,
    tagAccentLightDisabled: themePrimitives.accent50,
    tagAccentLightFont: themePrimitives.accent500,
    tagAccentLightFontHover: themePrimitives.accent500,
    tagAccentOutlinedActive: themePrimitives.accent600,
    tagAccentOutlinedFontHover: themePrimitives.accent400,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveFontDisabled: themePrimitives.positive200,
    tagPositiveOutlinedDisabled: themePrimitives.positive200,
    tagPositiveSolidFont: themePrimitives.white,
    tagPositiveSolidBackground: themePrimitives.positive400,
    tagPositiveOutlinedBackground: themePrimitives.positive200,
    tagPositiveOutlinedFont: themePrimitives.positive400,
    // Deprecated
    tagPositiveSolidHover: themePrimitives.positive50,
    tagPositiveSolidActive: themePrimitives.positive100,
    tagPositiveSolidDisabled: themePrimitives.positive50,
    tagPositiveSolidFontHover: themePrimitives.positive500,
    tagPositiveLightBackground: themePrimitives.positive50,
    tagPositiveLightHover: themePrimitives.positive100,
    tagPositiveLightActive: themePrimitives.positive100,
    tagPositiveLightDisabled: themePrimitives.positive50,
    tagPositiveLightFont: themePrimitives.positive500,
    tagPositiveLightFontHover: themePrimitives.positive500,
    tagPositiveOutlinedActive: themePrimitives.positive600,
    tagPositiveOutlinedFontHover: themePrimitives.positive400,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningFontDisabled: themePrimitives.warning300,
    tagWarningOutlinedDisabled: themePrimitives.warning300,
    tagWarningSolidFont: themePrimitives.warning700,
    tagWarningSolidBackground: themePrimitives.warning400,
    tagWarningOutlinedBackground: themePrimitives.warning300,
    tagWarningOutlinedFont: themePrimitives.warning600,
    // Deprecated
    tagWarningSolidHover: themePrimitives.warning50,
    tagWarningSolidActive: themePrimitives.warning100,
    tagWarningSolidDisabled: themePrimitives.warning50,
    tagWarningSolidFontHover: themePrimitives.warning500,
    tagWarningLightBackground: themePrimitives.warning50,
    tagWarningLightHover: themePrimitives.warning100,
    tagWarningLightActive: themePrimitives.warning100,
    tagWarningLightDisabled: themePrimitives.warning50,
    tagWarningLightFont: themePrimitives.warning500,
    tagWarningLightFontHover: themePrimitives.warning500,
    tagWarningOutlinedActive: themePrimitives.warning600,
    tagWarningOutlinedFontHover: themePrimitives.warning600,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeFontDisabled: themePrimitives.negative200,
    tagNegativeOutlinedDisabled: themePrimitives.negative200,
    tagNegativeSolidFont: themePrimitives.white,
    tagNegativeSolidBackground: themePrimitives.negative400,
    tagNegativeOutlinedBackground: themePrimitives.negative200,
    tagNegativeOutlinedFont: themePrimitives.negative400,
    // Deprecated
    tagNegativeSolidHover: themePrimitives.negative50,
    tagNegativeSolidActive: themePrimitives.negative100,
    tagNegativeSolidDisabled: themePrimitives.negative50,
    tagNegativeSolidFontHover: themePrimitives.negative500,
    tagNegativeLightBackground: themePrimitives.negative50,
    tagNegativeLightHover: themePrimitives.negative100,
    tagNegativeLightActive: themePrimitives.negative100,
    tagNegativeLightDisabled: themePrimitives.negative50,
    tagNegativeLightFont: themePrimitives.negative500,
    tagNegativeLightFontHover: themePrimitives.negative500,
    tagNegativeOutlinedActive: themePrimitives.negative600,
    tagNegativeOutlinedFontHover: themePrimitives.negative400,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: themePrimitives.mono100,
    tableBackground: themePrimitives.mono100,
    tableStripedBackground: themePrimitives.mono200,
    tableFilter: themePrimitives.mono600,
    tableFilterHeading: themePrimitives.mono700,
    tableFilterBackground: themePrimitives.mono100,
    tableFilterFooterBackground: themePrimitives.mono200,
    // Toast
    toastText: themePrimitives.white,
    toastPrimaryBackground: themePrimitives.primary500,
    toastInfoBackground: themePrimitives.accent500,
    toastPositiveBackground: themePrimitives.positive500,
    toastWarningBackground: themePrimitives.warning500,
    toastNegativeBackground: themePrimitives.negative500,
    // Spinner
    spinnerTrackFill: themePrimitives.mono900,
    // Progress bar
    progressbarTrackFill: themePrimitives.mono900,
    // Tooltip
    tooltipBackground: themePrimitives.mono900,
    tooltipText: themePrimitives.mono100
  };
});

/***/ }),

/***/ 10482:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43258);
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


/* ---- DEPRECATED ---- */
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
  return {
    // TODO(#2318) Remove Legacy Semantic Colors values in the next v11 major
    // since it's not used in the component specific tokens
    // and we ship semantic tokens separately

    /* ---- Legacy Semantic Colors ---- */
    // Font Color
    colorPrimary: themePrimitives.black,
    colorSecondary: themePrimitives.mono800,
    // Background
    background: themePrimitives.white,
    backgroundAlt: themePrimitives.white,
    backgroundInv: themePrimitives.primary,
    // Foreground
    foreground: themePrimitives.black,
    foregroundAlt: themePrimitives.mono800,
    foregroundInv: themePrimitives.white,
    // Borders
    border: themePrimitives.mono500,
    borderAlt: themePrimitives.mono600,
    borderFocus: themePrimitives.primary,
    borderError: themePrimitives.negative,
    // Shadow
    shadowFocus: 'rgba(39, 110, 241, 0.32)',
    shadowError: 'rgba(229, 73, 55, 0.32)'
  };
});

/***/ }),

/***/ 80217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43258);
/* harmony import */ var _styles_util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9471);
/* harmony import */ var _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99749);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
  var foundation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
  var core = {
    // Background
    backgroundPrimary: foundation.primaryB,
    backgroundSecondary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray50,
    backgroundTertiary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray100,
    backgroundInversePrimary: foundation.primaryA,
    backgroundInverseSecondary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray800,
    // Content
    contentPrimary: foundation.primaryA,
    contentSecondary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray600,
    contentTertiary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray500,
    contentInversePrimary: foundation.primaryB,
    contentInverseSecondary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray300,
    contentInverseTertiary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray400,
    // Border
    borderOpaque: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray200,
    borderTransparent: (0,_styles_util_js__WEBPACK_IMPORTED_MODULE_2__/* .hexToRgb */ .oo)(foundation.primaryA, '0.08'),
    borderSelected: foundation.primaryA,
    borderInverseOpaque: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray700,
    borderInverseTransparent: (0,_styles_util_js__WEBPACK_IMPORTED_MODULE_2__/* .hexToRgb */ .oo)(foundation.primaryB, '0.2'),
    borderInverseSelected: foundation.primaryB
  };
  var coreExtensions = {
    // Backgrounds
    backgroundStateDisabled: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray50,
    backgroundOverlayDark: (0,_styles_util_js__WEBPACK_IMPORTED_MODULE_2__/* .hexToRgb */ .oo)(_tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.black, '0.3'),
    backgroundOverlayLight: (0,_styles_util_js__WEBPACK_IMPORTED_MODULE_2__/* .hexToRgb */ .oo)(_tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.black, '0.08'),
    backgroundAccent: foundation.accent,
    backgroundNegative: foundation.negative,
    backgroundWarning: foundation.warning,
    backgroundPositive: foundation.positive,
    backgroundLightAccent: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.blue50,
    backgroundLightNegative: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.red50,
    backgroundLightWarning: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.yellow50,
    backgroundLightPositive: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.green50,
    backgroundAlwaysDark: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.black,
    backgroundAlwaysLight: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.white,
    // Content
    contentStateDisabled: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray400,
    contentAccent: foundation.accent,
    contentOnColor: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.white,
    contentOnColorInverse: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.black,
    contentNegative: foundation.negative,
    contentWarning: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.yellow700,
    contentPositive: foundation.positive,
    // Border
    borderStateDisabled: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.gray50,
    borderAccent: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.blue400,
    borderAccentLight: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.blue200,
    borderNegative: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.red200,
    borderWarning: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.yellow200,
    borderPositive: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.green200
  };
  return _objectSpread(_objectSpread({}, core), coreExtensions);
});

/***/ }),

/***/ 43258:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99749);
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

// color constants
var lightColorTokens = {
  // Primary Palette
  primaryA: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.black,
  primaryB: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.white,
  primary: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.black,
  primary50: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray50,
  primary100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray100,
  primary200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray200,
  primary300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray300,
  primary400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray400,
  primary500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray500,
  primary600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray600,
  primary700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray700,
  // Accent Palette
  accent: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.blue400,
  accent50: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.blue50,
  accent100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.blue100,
  accent200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.blue200,
  accent300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.blue300,
  accent400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.blue400,
  accent500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.blue500,
  accent600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.blue600,
  accent700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.blue700,
  // Negative Palette
  negative: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.red400,
  negative50: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.red50,
  negative100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.red100,
  negative200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.red200,
  negative300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.red300,
  negative400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.red400,
  negative500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.red500,
  negative600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.red600,
  negative700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.red700,
  // Warning Palette
  warning: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow400,
  warning50: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow50,
  warning100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow100,
  warning200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow200,
  warning300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow300,
  warning400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow400,
  warning500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow500,
  warning600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow600,
  warning700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow700,
  // Positive Palette
  positive: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.green500,
  positive50: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.green50,
  positive100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.green100,
  positive200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.green200,
  positive300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.green300,
  positive400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.green400,
  positive500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.green500,
  positive600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.green600,
  positive700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.green700,
  // Monochrome Palette
  white: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.white,
  black: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.black,
  mono100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.white,
  mono200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray50,
  mono300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray100,
  mono400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray200,
  mono500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray300,
  mono600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray400,
  mono700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray500,
  mono800: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray600,
  mono900: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray700,
  mono1000: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.black,
  // Rating Palette,
  rating200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow200,
  rating400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.yellow400,
  ratingInactiveFill: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray100,
  ratingStroke: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.gray300
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (lightColorTokens);

/***/ }),

/***/ 30889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var animation = {
  timing100: '100ms',
  timing200: '200ms',
  timing300: '300ms',
  timing400: '400ms',
  timing500: '500ms',
  timing600: '600ms',
  timing700: '700ms',
  timing800: '800ms',
  timing900: '900ms',
  timing1000: '1000ms',
  easeInCurve: 'cubic-bezier(.8, .2, .6, 1)',
  easeOutCurve: 'cubic-bezier(.2, .8, .4, 1)',
  easeInOutCurve: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeInQuinticCurve: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  easeOutQuinticCurve: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutQuinticCurve: 'cubic-bezier(0.86, 0, 0.07, 1)',
  linearCurve: 'cubic-bezier(0, 0, 1, 1)'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (animation);

/***/ }),

/***/ 23112:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// borderColor is defaulted to the light theme values.
// Dark theme overrides the border colors.
var borders = {
  border100: {
    borderColor: 'hsla(0, 0%, 0%, 0.04)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border200: {
    borderColor: 'hsla(0, 0%, 0%, 0.08)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border300: {
    borderColor: 'hsla(0, 0%, 0%, 0.12)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border400: {
    borderColor: 'hsla(0, 0%, 0%, 0.16)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border500: {
    borderColor: 'hsla(0, 0%, 0%, 0.2)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border600: {
    borderColor: 'hsla(0, 0%, 0%, 0.24)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  radius100: '2px',
  radius200: '4px',
  radius300: '8px',
  radius400: '12px',
  radius500: '16px',

  /** Datepicker (Range), Progress Bar, Slider, Tag */
  useRoundedCorners: true,

  /** Button, ButtonGroup */
  buttonBorderRadius: '0px',

  /** Input, Select, Textarea, Checkbox */
  inputBorderRadius: '0px',

  /** Popover, Menu, Tooltip */
  popoverBorderRadius: '0px',

  /** Card, Datepicker, Modal, Toast, Notification */
  surfaceBorderRadius: '0px',

  /** Tag */
  tagBorderRadius: '24px'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (borders);

/***/ }),

/***/ 1687:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var breakpoints = {
  small: 320,
  medium: 600,
  large: 1136
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (breakpoints);

/***/ }),

/***/ 67755:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var grid = {
  columns: [4, 8, 12],
  gutters: [16, 36, 36],
  margins: [16, 36, 64],
  gaps: 0,
  unit: 'px',
  maxWidth: 1280
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (grid);

/***/ }),

/***/ 63131:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var lighting = {
  shadow400: '0 1px 4px hsla(0, 0%, 0%, 0.16)',
  shadow500: '0 2px 8px hsla(0, 0%, 0%, 0.16)',
  shadow600: '0 4px 16px hsla(0, 0%, 0%, 0.16)',
  shadow700: '0 8px 24px hsla(0, 0%, 0%, 0.16)',
  overlay0: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0)',
  overlay100: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.04)',
  overlay200: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.08)',
  overlay300: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.12)',
  overlay400: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.16)',
  overlay500: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.2)',
  overlay600: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.24)'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (lighting);

/***/ }),

/***/ 84025:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80497);
/* harmony import */ var _breakpoints_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1687);
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


var mediaQuery = {
  small: (0,_helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .getMediaQuery */ .a)(_breakpoints_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.small),
  medium: (0,_helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .getMediaQuery */ .a)(_breakpoints_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.medium),
  large: (0,_helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .getMediaQuery */ .a)(_breakpoints_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.large)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (mediaQuery);

/***/ }),

/***/ 57049:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var sizing = {
  scale0: '2px',
  scale100: '4px',
  scale200: '6px',
  scale300: '8px',
  scale400: '10px',
  scale500: '12px',
  scale550: '14px',
  scale600: '16px',
  scale650: '18px',
  scale700: '20px',
  scale750: '22px',
  scale800: '24px',
  scale850: '28px',
  scale900: '32px',
  scale950: '36px',
  scale1000: '40px',
  scale1200: '48px',
  scale1400: '56px',
  scale1600: '64px',
  scale2400: '96px',
  scale3200: '128px',
  scale4800: '192px'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (sizing);

/***/ }),

/***/ 86081:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export defaultFontTokens */
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var defaultFontTokens = {
  primaryFontFamily: 'system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
};
var monoFontFamily = '"Lucida Console", Monaco, monospace';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
  var fontTokens = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultFontTokens;
  var font100 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: '20px'
  };
  var font150 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px'
  };
  var font200 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '20px'
  };
  var font250 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px'
  };
  var font300 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: '24px'
  };
  var font350 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px'
  };
  var font400 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '18px',
    fontWeight: 'normal',
    lineHeight: '28px'
  };
  var font450 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '24px'
  };
  var font550 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '28px'
  };
  var font650 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '32px'
  };
  var font750 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '28px',
    fontWeight: 500,
    lineHeight: '36px'
  };
  var font850 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '32px',
    fontWeight: 500,
    lineHeight: '40px'
  };
  var font950 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '36px',
    fontWeight: 500,
    lineHeight: '44px'
  };
  var font1050 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '40px',
    fontWeight: 500,
    lineHeight: '52px'
  };
  var font1150 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '36px',
    fontWeight: 500,
    lineHeight: '44px'
  };
  var font1250 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '44px',
    fontWeight: 500,
    lineHeight: '52px'
  };
  var font1350 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '52px',
    fontWeight: 500,
    lineHeight: '64px'
  };
  var font1450 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '96px',
    fontWeight: 500,
    lineHeight: '112px'
  };
  return {
    font100: font100,
    font150: font150,
    font200: font200,
    font250: font250,
    font300: font300,
    font350: font350,
    font400: font400,
    font450: font450,
    font550: font550,
    font650: font650,
    font750: font750,
    font850: font850,
    font950: font950,
    font1050: font1050,
    font1150: font1150,
    font1250: font1250,
    font1350: font1350,
    font1450: font1450,
    ParagraphXSmall: font100,
    ParagraphSmall: font200,
    ParagraphMedium: font300,
    ParagraphLarge: font400,
    LabelXSmall: font150,
    LabelSmall: font250,
    LabelMedium: font350,
    LabelLarge: font450,
    HeadingXSmall: font550,
    HeadingSmall: font650,
    HeadingMedium: font750,
    HeadingLarge: font850,
    HeadingXLarge: font950,
    HeadingXXLarge: font1050,
    DisplayXSmall: font1150,
    DisplaySmall: font1250,
    DisplayMedium: font1350,
    DisplayLarge: font1450,
    MonoParagraphXSmall: _objectSpread(_objectSpread({}, font100), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphSmall: _objectSpread(_objectSpread({}, font200), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphMedium: _objectSpread(_objectSpread({}, font300), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphLarge: _objectSpread(_objectSpread({}, font400), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelXSmall: _objectSpread(_objectSpread({}, font150), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelSmall: _objectSpread(_objectSpread({}, font250), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelMedium: _objectSpread(_objectSpread({}, font350), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelLarge: _objectSpread(_objectSpread({}, font450), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXSmall: _objectSpread(_objectSpread({}, font550), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingSmall: _objectSpread(_objectSpread({}, font650), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingMedium: _objectSpread(_objectSpread({}, font750), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingLarge: _objectSpread(_objectSpread({}, font850), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXLarge: _objectSpread(_objectSpread({}, font950), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXXLarge: _objectSpread(_objectSpread({}, font1050), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayXSmall: _objectSpread(_objectSpread({}, font1150), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplaySmall: _objectSpread(_objectSpread({}, font1250), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayMedium: _objectSpread(_objectSpread({}, font1350), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayLarge: _objectSpread(_objectSpread({}, font1450), {}, {
      fontFamily: monoFontFamily
    })
  };
});

/***/ }),

/***/ 99749:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var colors = {
  white: '#FFFFFF',
  gray50: '#F6F6F6',
  gray100: '#EEEEEE',
  gray200: '#E2E2E2',
  gray300: '#CBCBCB',
  gray400: '#AFAFAF',
  gray500: '#757575',
  gray600: '#545454',
  gray700: '#333333',
  gray800: '#1F1F1F',
  gray900: '#141414',
  black: '#000000',
  platinum50: '#F4FAFB',
  platinum100: '#EBF5F7',
  platinum200: '#CCDFE5',
  platinum300: '#A1BDCA',
  platinum400: '#8EA3AD',
  platinum500: '#6C7C83',
  platinum600: '#556268',
  platinum700: '#394145',
  platinum800: '#142328',
  red50: '#FFEFED',
  red100: '#FED7D2',
  red200: '#F1998E',
  red300: '#E85C4A',
  red400: '#E11900',
  red500: '#AB1300',
  red600: '#870F00',
  red700: '#5A0A00',
  orange50: '#FFF3EF',
  orange100: '#FFE1D6',
  orange200: '#FABDA5',
  orange300: '#FA9269',
  orange400: '#FF6937',
  orange500: '#C14F29',
  orange600: '#9A3F21',
  orange700: '#672A16',
  yellow50: '#FFFAF0',
  yellow100: '#FFF2D9',
  yellow200: '#FFE3AC',
  yellow300: '#FFCF70',
  yellow400: '#FFC043',
  yellow500: '#BC8B2C',
  yellow600: '#997328',
  yellow700: '#674D1B',
  green50: '#E6F2ED',
  green100: '#ADDEC9',
  green200: '#66D19E',
  green300: '#06C167',
  green400: '#05944F',
  green500: '#03703C',
  green600: '#03582F',
  green700: '#10462D',
  blue50: '#EFF3FE',
  blue100: '#D4E2FC',
  blue200: '#A0BFF8',
  blue300: '#5B91F5',
  blue400: '#276EF1',
  blue500: '#1E54B7',
  blue600: '#174291',
  blue700: '#102C60',
  cobalt50: '#EBEDFA',
  cobalt100: '#D2D7F0',
  cobalt200: '#949CE3',
  cobalt300: '#535FCF',
  cobalt400: '#0E1FC1',
  cobalt500: '#0A1899',
  cobalt600: '#081270',
  cobalt700: '#050C4D',
  purple50: '#F3F1F9',
  purple100: '#E3DDF2',
  purple200: '#C1B4E2',
  purple300: '#957FCE',
  purple400: '#7356BF',
  purple500: '#574191',
  purple600: '#453473',
  purple700: '#2E224C',
  brown50: '#F6F0EA',
  brown100: '#EBE0DB',
  brown200: '#D2BBB0',
  brown300: '#B18977',
  brown400: '#99644C',
  brown500: '#744C3A',
  brown600: '#5C3C2E',
  brown700: '#3D281E'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (colors);

/***/ }),

/***/ 69176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ deepMerge)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable flowtype/no-weak-types */
function deepMerge(target) {
  target = target || {};
  var len = arguments.length <= 1 ? 0 : arguments.length - 1;
  var obj;
  var value;

  for (var i = 0; i < len; i++) {
    obj = (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) || {};

    for (var key in obj) {
      if (_typeof(obj[key]) !== undefined) {
        value = obj[key];

        if (isCloneable(value)) {
          target[key] = deepMerge(
          /* eslint-disable-next-line no-mixed-operators */
          target[key] || Array.isArray(value) && [] || {}, value);
        } else {
          target[key] = value;
        }
      }
    }
  }

  return target;
}
/* eslint-enable flowtype/no-weak-types */

/* eslint-disable-next-line flowtype/no-weak-types */

function isCloneable(obj) {
  /* eslint-disable-next-line eqeqeq */
  return Array.isArray(obj) || {}.toString.call(obj) == '[object Object]';
}

/***/ }),

/***/ 27247:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ah: () => (/* binding */ forkFocus),
/* harmony export */   E: () => (/* binding */ isFocusVisible),
/* harmony export */   L: () => (/* binding */ initFocusVisible),
/* harmony export */   Z5: () => (/* binding */ forkBlur)
/* harmony export */ });
/* unused harmony exports teardown, handleBlurVisible */
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// based on:
// - https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/focusVisible.js
// - https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var initialized = false;
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
} //$FlowFixMe


function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
} //$FlowFixMe

function isFocusVisible(event) {
  try {
    return event.target.matches(':focus-visible');
  } catch (error) {// browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  } // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(event.target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */

function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;

  if (typeof document !== 'undefined') {
    window.clearTimeout(hadFocusVisibleRecentlyTimeout);
    hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
      hadFocusVisibleRecently = false;
    }, 100);
  }
} //$FlowFixMe

function initFocusVisible(node) {
  if (!initialized && node != null) {
    initialized = true;
    prepare(node.ownerDocument);
  }
}
var forkFocus = function forkFocus(rootProps, handler) {
  return function (e) {
    if (typeof rootProps.onFocus === 'function') {
      rootProps.onFocus(e);
    }

    handler(e);
  };
};
var forkBlur = function forkBlur(rootProps, handler) {
  return function (e) {
    if (typeof rootProps.onBlur === 'function') {
      rootProps.onBlur(e);
    }

    handler(e);
  };
};

/***/ }),

/***/ 7046:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (hyphenateStyleName);


/***/ }),

/***/ 21700:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {}

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ 53269:
/***/ ((module) => {

module.exports = extend;

/*
  var obj = {a: 3, b: 5};
  extend(obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 4, b: 5, c: 8}

  var obj = {a: 3, b: 5};
  extend({}, obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 3, b: 5}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4]}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(true, obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3]}

  extend({a: 4, b: 5}); // {a: 4, b: 5}
  extend({a: 4, b: 5}, 3); {a: 4, b: 5}
  extend({a: 4, b: 5}, true); {a: 4, b: 5}
  extend('hello', {a: 4, b: 5}); // throws
  extend(3, {a: 4, b: 5}); // throws
*/

function extend(/* [deep], obj1, obj2, [objn] */) {
  var args = [].slice.call(arguments);
  var deep = false;
  if (typeof args[0] == 'boolean') {
    deep = args.shift();
  }
  var result = args[0];
  if (isUnextendable(result)) {
    throw new Error('extendee must be an object');
  }
  var extenders = args.slice(1);
  var len = extenders.length;
  for (var i = 0; i < len; i++) {
    var extender = extenders[i];
    for (var key in extender) {
      if (extender.hasOwnProperty(key)) {
        var value = extender[key];
        if (deep && isCloneable(value)) {
          var base = Array.isArray(value) ? [] : {};
          result[key] = extend(
            true,
            result.hasOwnProperty(key) && !isUnextendable(result[key])
              ? result[key]
              : base,
            value
          );
        } else {
          result[key] = value;
        }
      }
    }
  }
  return result;
}

function isCloneable(obj) {
  return Array.isArray(obj) || {}.toString.call(obj) == '[object Object]';
}

function isUnextendable(val) {
  return !val || (typeof val != 'object' && typeof val != 'function');
}


/***/ }),

/***/ 22764:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Qj: () => (/* reexport */ ObserverComponent),
  Pi: () => (/* reexport */ observer),
  fv: () => (/* reexport */ useLocalObservable)
});

// UNUSED EXPORTS: clearTimers, enableStaticRendering, isObserverBatched, isUsingStaticRendering, observerBatching, useAsObservableSource, useLocalStore, useObserver, useStaticRendering

// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx@6.5.0/node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(77662);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/assertEnvironment.js


if (!react.useState) {
    throw new Error("mobx-react-lite requires React with Hooks support");
}
if (!mobx_esm.makeObservable) {
    throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
}
//# sourceMappingURL=assertEnvironment.js.map
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/react-dom/index.js
var react_dom = __webpack_require__(5556);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/reactBatchedUpdates.js

//# sourceMappingURL=reactBatchedUpdates.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/observerBatching.js

function defaultNoopBatch(callback) {
    callback();
}
function observerBatching(reactionScheduler) {
    if (!reactionScheduler) {
        reactionScheduler = defaultNoopBatch;
        if (false) {}
    }
    (0,mobx_esm.configure)({ reactionScheduler: reactionScheduler });
}
var isObserverBatched = function () {
    if (false) {}
    return true;
};
//# sourceMappingURL=observerBatching.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/printDebugValue.js

function printDebugValue(v) {
    return (0,mobx_esm.getDependencyTree)(v);
}
//# sourceMappingURL=printDebugValue.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/FinalizationRegistryWrapper.js
var FinalizationRegistryLocal = typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry;

//# sourceMappingURL=FinalizationRegistryWrapper.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/reactionCleanupTrackingCommon.js
function createTrackingData(reaction) {
    var trackingData = {
        reaction: reaction,
        mounted: false,
        changedBeforeMount: false,
        cleanAt: Date.now() + CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS
    };
    return trackingData;
}
/**
 * The minimum time before we'll clean up a Reaction created in a render
 * for a component that hasn't managed to run its effects. This needs to
 * be big enough to ensure that a component won't turn up and have its
 * effects run without being re-rendered.
 */
var CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS = 10000;
/**
 * The frequency with which we'll check for leaked reactions.
 */
var CLEANUP_TIMER_LOOP_MILLIS = 10000;
//# sourceMappingURL=reactionCleanupTrackingCommon.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/createReactionCleanupTrackingUsingFinalizationRegister.js

/**
 * FinalizationRegistry-based uncommitted reaction cleanup
 */
function createReactionCleanupTrackingUsingFinalizationRegister(FinalizationRegistry) {
    var cleanupTokenToReactionTrackingMap = new Map();
    var globalCleanupTokensCounter = 1;
    var registry = new FinalizationRegistry(function cleanupFunction(token) {
        var trackedReaction = cleanupTokenToReactionTrackingMap.get(token);
        if (trackedReaction) {
            trackedReaction.reaction.dispose();
            cleanupTokenToReactionTrackingMap.delete(token);
        }
    });
    return {
        addReactionToTrack: function (reactionTrackingRef, reaction, objectRetainedByReact) {
            var token = globalCleanupTokensCounter++;
            registry.register(objectRetainedByReact, token, reactionTrackingRef);
            reactionTrackingRef.current = createTrackingData(reaction);
            reactionTrackingRef.current.finalizationRegistryCleanupToken = token;
            cleanupTokenToReactionTrackingMap.set(token, reactionTrackingRef.current);
            return reactionTrackingRef.current;
        },
        recordReactionAsCommitted: function (reactionRef) {
            registry.unregister(reactionRef);
            if (reactionRef.current && reactionRef.current.finalizationRegistryCleanupToken) {
                cleanupTokenToReactionTrackingMap.delete(reactionRef.current.finalizationRegistryCleanupToken);
            }
        },
        forceCleanupTimerToRunNowForTests: function () {
            // When FinalizationRegistry in use, this this is no-op
        },
        resetCleanupScheduleForTests: function () {
            // When FinalizationRegistry in use, this this is no-op
        }
    };
}
//# sourceMappingURL=createReactionCleanupTrackingUsingFinalizationRegister.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/createTimerBasedReactionCleanupTracking.js
var __values = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

/**
 * timers, gc-style, uncommitted reaction cleanup
 */
function createTimerBasedReactionCleanupTracking() {
    /**
     * Reactions created by components that have yet to be fully mounted.
     */
    var uncommittedReactionRefs = new Set();
    /**
     * Latest 'uncommitted reactions' cleanup timer handle.
     */
    var reactionCleanupHandle;
    /* istanbul ignore next */
    /**
     * Only to be used by test functions; do not export outside of mobx-react-lite
     */
    function forceCleanupTimerToRunNowForTests() {
        // This allows us to control the execution of the cleanup timer
        // to force it to run at awkward times in unit tests.
        if (reactionCleanupHandle) {
            clearTimeout(reactionCleanupHandle);
            cleanUncommittedReactions();
        }
    }
    /* istanbul ignore next */
    function resetCleanupScheduleForTests() {
        var e_1, _a;
        if (uncommittedReactionRefs.size > 0) {
            try {
                for (var uncommittedReactionRefs_1 = __values(uncommittedReactionRefs), uncommittedReactionRefs_1_1 = uncommittedReactionRefs_1.next(); !uncommittedReactionRefs_1_1.done; uncommittedReactionRefs_1_1 = uncommittedReactionRefs_1.next()) {
                    var ref = uncommittedReactionRefs_1_1.value;
                    var tracking = ref.current;
                    if (tracking) {
                        tracking.reaction.dispose();
                        ref.current = null;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (uncommittedReactionRefs_1_1 && !uncommittedReactionRefs_1_1.done && (_a = uncommittedReactionRefs_1.return)) _a.call(uncommittedReactionRefs_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            uncommittedReactionRefs.clear();
        }
        if (reactionCleanupHandle) {
            clearTimeout(reactionCleanupHandle);
            reactionCleanupHandle = undefined;
        }
    }
    function ensureCleanupTimerRunning() {
        if (reactionCleanupHandle === undefined) {
            reactionCleanupHandle = setTimeout(cleanUncommittedReactions, CLEANUP_TIMER_LOOP_MILLIS);
        }
    }
    function scheduleCleanupOfReactionIfLeaked(ref) {
        uncommittedReactionRefs.add(ref);
        ensureCleanupTimerRunning();
    }
    function recordReactionAsCommitted(reactionRef) {
        uncommittedReactionRefs.delete(reactionRef);
    }
    /**
     * Run by the cleanup timer to dispose any outstanding reactions
     */
    function cleanUncommittedReactions() {
        reactionCleanupHandle = undefined;
        // Loop through all the candidate leaked reactions; those older
        // than CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS get tidied.
        var now = Date.now();
        uncommittedReactionRefs.forEach(function (ref) {
            var tracking = ref.current;
            if (tracking) {
                if (now >= tracking.cleanAt) {
                    // It's time to tidy up this leaked reaction.
                    tracking.reaction.dispose();
                    ref.current = null;
                    uncommittedReactionRefs.delete(ref);
                }
            }
        });
        if (uncommittedReactionRefs.size > 0) {
            // We've just finished a round of cleanups but there are still
            // some leak candidates outstanding.
            ensureCleanupTimerRunning();
        }
    }
    return {
        addReactionToTrack: function (reactionTrackingRef, reaction, 
        /**
         * On timer based implementation we don't really need this object,
         * but we keep the same api
         */
        objectRetainedByReact) {
            reactionTrackingRef.current = createTrackingData(reaction);
            scheduleCleanupOfReactionIfLeaked(reactionTrackingRef);
            return reactionTrackingRef.current;
        },
        recordReactionAsCommitted: recordReactionAsCommitted,
        forceCleanupTimerToRunNowForTests: forceCleanupTimerToRunNowForTests,
        resetCleanupScheduleForTests: resetCleanupScheduleForTests
    };
}
//# sourceMappingURL=createTimerBasedReactionCleanupTracking.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/reactionCleanupTracking.js



var _a = FinalizationRegistryLocal
    ? createReactionCleanupTrackingUsingFinalizationRegister(FinalizationRegistryLocal)
    : createTimerBasedReactionCleanupTracking(), addReactionToTrack = _a.addReactionToTrack, recordReactionAsCommitted = _a.recordReactionAsCommitted, resetCleanupScheduleForTests = _a.resetCleanupScheduleForTests, forceCleanupTimerToRunNowForTests = _a.forceCleanupTimerToRunNowForTests;

//# sourceMappingURL=reactionCleanupTracking.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/staticRendering.js
var globalIsUsingStaticRendering = false;
function staticRendering_enableStaticRendering(enable) {
    globalIsUsingStaticRendering = enable;
}
function isUsingStaticRendering() {
    return globalIsUsingStaticRendering;
}
//# sourceMappingURL=staticRendering.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useObserver.js
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





function observerComponentNameFor(baseComponentName) {
    return "observer".concat(baseComponentName);
}
/**
 * We use class to make it easier to detect in heap snapshots by name
 */
var ObjectToBeRetainedByReact = /** @class */ (function () {
    function ObjectToBeRetainedByReact() {
    }
    return ObjectToBeRetainedByReact;
}());
function objectToBeRetainedByReactFactory() {
    return new ObjectToBeRetainedByReact();
}
function useObserver(fn, baseComponentName) {
    if (baseComponentName === void 0) { baseComponentName = "observed"; }
    if (isUsingStaticRendering()) {
        return fn();
    }
    var _a = __read(react.useState(objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
    // Force update, see #2982
    var _b = __read(react.useState(), 2), setState = _b[1];
    var forceUpdate = function () { return setState([]); };
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var reactionTrackingRef = react.useRef(null);
    if (!reactionTrackingRef.current) {
        // First render for this component (or first time since a previous
        // reaction from an abandoned render was disposed).
        var newReaction = new mobx_esm.Reaction(observerComponentNameFor(baseComponentName), function () {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (trackingData_1.mounted) {
                // We have reached useEffect(), so we're mounted, and can trigger an update
                forceUpdate();
            }
            else {
                // We haven't yet reached useEffect(), so we'll need to trigger a re-render
                // when (and if) useEffect() arrives.
                trackingData_1.changedBeforeMount = true;
            }
        });
        var trackingData_1 = addReactionToTrack(reactionTrackingRef, newReaction, objectRetainedByReact);
    }
    var reaction = reactionTrackingRef.current.reaction;
    react.useDebugValue(reaction, printDebugValue);
    react.useEffect(function () {
        // Called on first mount only
        recordReactionAsCommitted(reactionTrackingRef);
        if (reactionTrackingRef.current) {
            // Great. We've already got our reaction from our render;
            // all we need to do is to record that it's now mounted,
            // to allow future observable changes to trigger re-renders
            reactionTrackingRef.current.mounted = true;
            // Got a change before first mount, force an update
            if (reactionTrackingRef.current.changedBeforeMount) {
                reactionTrackingRef.current.changedBeforeMount = false;
                forceUpdate();
            }
        }
        else {
            // The reaction we set up in our render has been disposed.
            // This can be due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up
            // Re-create the reaction
            reactionTrackingRef.current = {
                reaction: new mobx_esm.Reaction(observerComponentNameFor(baseComponentName), function () {
                    // We've definitely already been mounted at this point
                    forceUpdate();
                }),
                mounted: true,
                changedBeforeMount: false,
                cleanAt: Infinity
            };
            forceUpdate();
        }
        return function () {
            reactionTrackingRef.current.reaction.dispose();
            reactionTrackingRef.current = null;
        };
    }, []);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var rendering;
    var exception;
    reaction.track(function () {
        try {
            rendering = fn();
        }
        catch (e) {
            exception = e;
        }
    });
    if (exception) {
        throw exception; // re-throw any exceptions caught during rendering
    }
    return rendering;
}
//# sourceMappingURL=useObserver.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/observer.js



var warnObserverOptionsDeprecated = true;
var hasSymbol = typeof Symbol === "function" && Symbol.for;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var ReactForwardRefSymbol = hasSymbol
    ? Symbol.for("react.forward_ref")
    : typeof react.forwardRef === "function" && (0,react.forwardRef)(function (props) { return null; })["$$typeof"];
var ReactMemoSymbol = hasSymbol
    ? Symbol.for("react.memo")
    : typeof react.memo === "function" && (0,react.memo)(function (props) { return null; })["$$typeof"];
// n.b. base case is not used for actual typings or exported in the typing files
function observer(baseComponent, 
// TODO remove in next major
options) {
    var _a;
    if (false) {}
    if (ReactMemoSymbol && baseComponent["$$typeof"] === ReactMemoSymbol) {
        throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    }
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if (isUsingStaticRendering()) {
        return baseComponent;
    }
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if (ReactForwardRefSymbol && baseComponent["$$typeof"] === ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") {
            throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
        }
    }
    var observerComponent = function (props, ref) {
        return useObserver(function () { return render(props, ref); }, baseComponentName);
    };
    // Don't set `displayName` for anonymous components,
    // so the `displayName` can be customized by user, see #3192.
    if (baseComponentName !== "") {
        ;
        observerComponent.displayName = baseComponentName;
    }
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) {
        ;
        observerComponent.contextTypes = baseComponent.contextTypes;
    }
    if (useForwardRef) {
        // `forwardRef` must be applied prior `memo`
        // `forwardRef(observer(cmp))` throws:
        // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
        observerComponent = (0,react.forwardRef)(observerComponent);
    }
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0,react.memo)(observerComponent);
    copyStaticProperties(baseComponent, observerComponent);
    if (false) {}
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function copyStaticProperties(base, target) {
    Object.keys(base).forEach(function (key) {
        if (!hoistBlackList[key]) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
        }
    });
}
//# sourceMappingURL=observer.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/ObserverComponent.js

function ObserverComponent(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") {
        return null;
    }
    return useObserver(component);
}
if (false) {}
ObserverComponent.displayName = "Observer";

function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) {
        return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    }
    if (hasProp || hasExtraProp) {
        return null;
    }
    return new Error("Invalid prop `" +
        propFullName +
        "` of type `" +
        typeof props[key] +
        "` supplied to" +
        " `" +
        componentName +
        "`, expected `function`.");
}
//# sourceMappingURL=ObserverComponent.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useLocalObservable.js


function useLocalObservable(initializer, annotations) {
    return (0,react.useState)(function () { return (0,mobx_esm.observable)(initializer(), annotations, { autoBind: true }); })[0];
}
//# sourceMappingURL=useLocalObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useAsObservableSource.js
var useAsObservableSource_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};



function useAsObservableSource_useAsObservableSource(current) {
    if (false)
        {}
    var _a = useAsObservableSource_read(useState(function () { return observable(current, {}, { deep: false }); }), 1), res = _a[0];
    runInAction(function () {
        Object.assign(res, current);
    });
    return res;
}
//# sourceMappingURL=useAsObservableSource.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useLocalStore.js




function useLocalStore(initializer, current) {
    if (false)
        {}
    var source = current && useAsObservableSource(current);
    return useState(function () { return observable(initializer(source), undefined, { autoBind: true }); })[0];
}
//# sourceMappingURL=useLocalStore.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js






observerBatching(react_dom.unstable_batchedUpdates);







function es_useObserver(fn, baseComponentName) {
    if (baseComponentName === void 0) { baseComponentName = "observed"; }
    if (false) {}
    return useObserverOriginal(fn, baseComponentName);
}

function useStaticRendering(enable) {
    if (false) {}
    enableStaticRendering(enable);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 86946:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ZP: () => (/* binding */ es2015)
});

// UNUSED EXPORTS: AutoFocusInside, FocusLockUI, FreeFocusInside, InFocusGuard, MoveFocusInside, useFocusInside

// EXTERNAL MODULE: ../../node_modules/.pnpm/@babel+runtime@7.20.7/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(60851);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@babel+runtime@7.20.7/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(5248);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/constants.js
/**
 * defines a focus group
 */
var FOCUS_GROUP = 'data-focus-lock';
/**
 * disables element discovery inside a group marked by key
 */
var FOCUS_DISABLED = 'data-focus-lock-disabled';
/**
 * allows uncontrolled focus within the marked area, effectively disabling focus lock for it's content
 */
var FOCUS_ALLOW = 'data-no-focus-lock';
/**
 * instructs autofocus engine to pick default autofocus inside a given node
 * can be set on the element or container
 */
var FOCUS_AUTO = 'data-autofocus-inside';
/**
 * instructs autofocus to ignore elements within a given node
 * can be set on the element or container
 */
var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

// EXTERNAL MODULE: ../../node_modules/.pnpm/use-callback-ref@1.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/use-callback-ref/dist/es2015/useMergeRef.js + 2 modules
var useMergeRef = __webpack_require__(4048);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-focus-lock@2.9.6_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-focus-lock/dist/es2015/FocusGuard.js


var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

var InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && /*#__PURE__*/react.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};

InFocusGuard.propTypes =  false ? 0 : {};
InFocusGuard.defaultProps = {
  children: null
};
/* harmony default export */ const FocusGuard = ((/* unused pure expression or super */ null && (InFocusGuard)));
// EXTERNAL MODULE: ../../node_modules/.pnpm/use-sidecar@1.1.2_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/use-sidecar/dist/es2015/medium.js
var medium = __webpack_require__(93711);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-focus-lock@2.9.6_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-focus-lock/dist/es2015/medium.js

var mediumFocus = (0,medium/* createMedium */.s)({}, function (_ref) {
  var target = _ref.target,
      currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = (0,medium/* createMedium */.s)();
var mediumEffect = (0,medium/* createMedium */.s)();
var mediumSidecar = (0,medium/* createSidecarMedium */._)({
  async: true // focus-lock sidecar is not required on the server
  // however, it might be required for JSDOM tests
  // ssr: true,

});
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-focus-lock@2.9.6_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-focus-lock/dist/es2015/Lock.js








var emptyArray = [];
var FocusLock = /*#__PURE__*/react.forwardRef(function FocusLockUI(props, parentRef) {
  var _extends2;

  var _React$useState = react.useState(),
      realObserved = _React$useState[0],
      setObserved = _React$useState[1];

  var observed = react.useRef();
  var isActive = react.useRef(false);
  var originalFocusedElement = react.useRef(null);
  var children = props.children,
      disabled = props.disabled,
      noFocusGuards = props.noFocusGuards,
      persistentFocus = props.persistentFocus,
      crossFrame = props.crossFrame,
      autoFocus = props.autoFocus,
      allowTextSelection = props.allowTextSelection,
      group = props.group,
      className = props.className,
      whiteList = props.whiteList,
      hasPositiveIndices = props.hasPositiveIndices,
      _props$shards = props.shards,
      shards = _props$shards === void 0 ? emptyArray : _props$shards,
      _props$as = props.as,
      Container = _props$as === void 0 ? 'div' : _props$as,
      _props$lockProps = props.lockProps,
      containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
      SideCar = props.sideCar,
      shouldReturnFocus = props.returnFocus,
      focusOptions = props.focusOptions,
      onActivationCallback = props.onActivation,
      onDeactivationCallback = props.onDeactivation;

  var _React$useState2 = react.useState({}),
      id = _React$useState2[0]; // SIDE EFFECT CALLBACKS


  var onActivation = react.useCallback(function () {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;

    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }

    isActive.current = true;
  }, [onActivationCallback]);
  var onDeactivation = react.useCallback(function () {
    isActive.current = false;

    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  (0,react.useEffect)(function () {
    if (!disabled) {
      // cleanup return focus on trap deactivation
      // sideEffect/returnFocus should happen by this time
      originalFocusedElement.current = null;
    }
  }, []);
  var returnFocus = react.useCallback(function (allowDefer) {
    var returnFocusTo = originalFocusedElement.current;

    if (returnFocusTo && returnFocusTo.focus) {
      var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;

      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
        originalFocusedElement.current = null;

        if (allowDefer) {
          // React might return focus after update
          // it's safer to defer the action
          Promise.resolve().then(function () {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]); // MEDIUM CALLBACKS

  var onFocus = react.useCallback(function (event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur = mediumBlur.useMedium; // REF PROPAGATION
  // not using real refs due to race conditions

  var setObserveNode = react.useCallback(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);

  if (false) {}

  var lockProps = (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);

  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = (0,useMergeRef/* useMergeRefs */.q)([parentRef, setObserveNode]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, hasLeadingGuards && [
  /*#__PURE__*/
  // nearest focus guard
  react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }), // first tabbed element guard
  hasPositiveIndices ? /*#__PURE__*/react.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  }) : null], !disabled && /*#__PURE__*/react.createElement(SideCar, {
    id: id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus,
    focusOptions: focusOptions
  }), /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), children), hasTailingGuards && /*#__PURE__*/react.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes =  false ? 0 : {};
FocusLock.defaultProps = {
  children: undefined,
  disabled: false,
  returnFocus: false,
  focusOptions: undefined,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  crossFrame: true,
  hasPositiveIndices: undefined,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};
/* harmony default export */ const Lock = (FocusLock);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@babel+runtime@7.20.7/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81926);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@babel+runtime@7.20.7/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(45233);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-clientside-effect@1.2.6_react@0.0.0-experimental-4ead6b530/node_modules/react-clientside-effect/lib/index.es.js




function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (false) {}

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (false) {}

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      (0,inheritsLoose/* default */.Z)(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/react.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(react.PureComponent);

    (0,defineProperty/* default */.Z)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

/* harmony default export */ const index_es = (withSideEffect);

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/array.js
/*
IE11 support
 */
var toArray = function (a) {
    var ret = Array(a.length);
    for (var i = 0; i < a.length; ++i) {
        ret[i] = a[i];
    }
    return ret;
};
var asArray = function (a) { return (Array.isArray(a) ? a : [a]); };
var getFirst = function (a) { return (Array.isArray(a) ? a[0] : a); };

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/is.js

var isElementHidden = function (node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
    }
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) {
        return false;
    }
    return (computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden');
};
var getParentNode = function (node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            node.parentNode.host
        : node.parentNode;
};
var isTopNode = function (node) {
    // @ts-ignore
    return node === document || (node && node.nodeType === Node.DOCUMENT_NODE);
};
var isVisibleUncached = function (node, checkParent) {
    return !node || isTopNode(node) || (!isElementHidden(node) && checkParent(getParentNode(node)));
};
var isVisibleCached = function (visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var isAutoFocusAllowedUncached = function (node, checkParent) {
    return node && !isTopNode(node) ? (isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false) : true;
};
var isAutoFocusAllowedCached = function (cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var getDataset = function (node) {
    // @ts-ignore
    return node.dataset;
};
var isHTMLButtonElement = function (node) { return node.tagName === 'BUTTON'; };
var isHTMLInputElement = function (node) { return node.tagName === 'INPUT'; };
var isRadioElement = function (node) {
    return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function (node) {
    return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
};
var isAutoFocusAllowed = function (node) {
    var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
    return ![true, 'true', ''].includes(attribute);
};
var isGuard = function (node) { var _a; return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard)); };
var isNotAGuard = function (node) { return !isGuard(node); };
var isDefined = function (x) { return Boolean(x); };

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/tabOrder.js

var tabSort = function (a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) {
            return 1;
        }
        if (!b.tabIndex) {
            return -1;
        }
    }
    return tabDiff || indexDiff;
};
var orderByTabIndex = function (nodes, filterNegative, keepGuards) {
    return toArray(nodes)
        .map(function (node, index) { return ({
        node: node,
        index: index,
        tabIndex: keepGuards && node.tabIndex === -1 ? ((node.dataset || {}).focusGuard ? 0 : -1) : node.tabIndex,
    }); })
        .filter(function (data) { return !filterNegative || data.tabIndex >= 0; })
        .sort(tabSort);
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/tabbables.js
/**
 * list of the object to be considered as focusable
 */
var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]',
];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/tabUtils.js



var queryTabbables = tabbables.join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function (parent, withGuards) {
    return toArray((parent.shadowRoot || parent).children).reduce(function (acc, child) {
        return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
    }, []);
};
var getFocusablesWithIFrame = function (parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
        return getFocusables([parent.contentDocument.body], withGuards);
    }
    return [parent];
};
var getFocusables = function (parents, withGuards) {
    return parents.reduce(function (acc, parent) {
        var _a;
        var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function (node) { return getFocusablesWithIFrame(node, withGuards); }));
        return acc.concat(
        // add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, 
        // add if node is tabbable itself
        parent.parentNode
            ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) { return node === parent; })
            : []);
    }, []);
};
/**
 * return a list of focusable nodes within an area marked as "auto-focusable"
 * @param parent
 */
var getParentAutofocusables = function (parent) {
    var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
    return toArray(parentFocus)
        .map(function (node) { return getFocusables([node]); })
        .reduce(function (acc, nodes) { return acc.concat(nodes); }, []);
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/DOMutils.js




/**
 * given list of focusable elements keeps the ones user can interact with
 * @param nodes
 * @param visibilityCache
 */
var filterFocusable = function (nodes, visibilityCache) {
    return toArray(nodes)
        .filter(function (node) { return isVisibleCached(visibilityCache, node); })
        .filter(function (node) { return notHiddenInput(node); });
};
var filterAutoFocusable = function (nodes, cache) {
    if (cache === void 0) { cache = new Map(); }
    return toArray(nodes).filter(function (node) { return isAutoFocusAllowedCached(cache, node); });
};
/**
 * !__WARNING__! Low level API.
 * @returns all tabbable nodes
 *
 * @see {@link getFocusableNodes} to get any focusable element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getTabbableNodes = function (topNodes, visibilityCache, withGuards) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
/**
 * !__WARNING__! Low level API.
 *
 * @returns anything "focusable", not only tabbable. The difference is in `tabIndex=-1`
 * (without guards, as long as they are not expected to be ever focused)
 *
 * @see {@link getTabbableNodes} to get only tabble nodes element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getFocusableNodes = function (topNodes, visibilityCache) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
/**
 * return list of nodes which are expected to be auto-focused
 * @param topNode
 * @param visibilityCache
 */
var parentAutofocusables = function (topNode, visibilityCache) {
    return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
/*
 * Determines if element is contained in scope, including nested shadow DOMs
 */
var contains = function (scope, element) {
    if (scope.shadowRoot) {
        return contains(scope.shadowRoot, element);
    }
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined &&
            Object.getPrototypeOf(scope).contains.call(scope, element)) {
            return true;
        }
        return toArray(scope.children).some(function (child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) {
                    return contains(iframeBody, element);
                }
                return false;
            }
            return contains(child, element);
        });
    }
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/safe.js
var safeProbe = function (cb) {
    try {
        return cb();
    }
    catch (e) {
        return undefined;
    }
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/getActiveElement.js
/**
 * returns active element from document or from nested shadowdoms
 */

/**
 * returns current active element. If the active element is a "container" itself(shadowRoot or iframe) returns active element inside it
 * @param [inDocument]
 */
var getActiveElement = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    if (!inDocument || !inDocument.activeElement) {
        return undefined;
    }
    var activeElement = inDocument.activeElement;
    return (activeElement.shadowRoot
        ? getActiveElement(activeElement.shadowRoot)
        : activeElement instanceof HTMLIFrameElement && safeProbe(function () { return activeElement.contentWindow.document; })
            ? getActiveElement(activeElement.contentWindow.document)
            : activeElement);
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/focusIsHidden.js




/**
 * checks if focus is hidden FROM the focus-lock
 * ie contained inside a node focus-lock shall ignore
 *
 * This is a utility function coupled with {@link FOCUS_ALLOW} constant
 *
 * @returns {boolean} focus is currently is in "allow" area
 */
var focusIsHidden = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    var activeElement = getActiveElement(inDocument);
    if (!activeElement) {
        return false;
    }
    // this does not support setting FOCUS_ALLOW within shadow dom
    return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) { return contains(node, activeElement); });
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/all-affected.js


/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */
var filterNested = function (nodes) {
    var contained = new Set();
    var l = nodes.length;
    for (var i = 0; i < l; i += 1) {
        for (var j = i + 1; j < l; j += 1) {
            var position = nodes[i].compareDocumentPosition(nodes[j]);
            /* eslint-disable no-bitwise */
            if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
                contained.add(j);
            }
            if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
                contained.add(i);
            }
            /* eslint-enable */
        }
    }
    return nodes.filter(function (_, index) { return !contained.has(index); });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */
var getTopParent = function (node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
/**
 * returns all "focus containers" inside a given node
 * @param node - node or nodes to look inside
 * @returns Element[]
 */
var getAllAffectedNodes = function (node) {
    var nodes = asArray(node);
    return nodes.filter(Boolean).reduce(function (acc, currentNode) {
        var group = currentNode.getAttribute(FOCUS_GROUP);
        acc.push.apply(acc, (group
            ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])"))))
            : [currentNode]));
        return acc;
    }, []);
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/focusInside.js




var focusInFrame = function (frame, activeElement) { return frame === activeElement; };
var focusInsideIframe = function (topNode, activeElement) {
    return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) { return focusInFrame(node, activeElement); }));
};
/**
 * @returns {Boolean} true, if the current focus is inside given node or nodes.
 * Supports nodes hidden inside shadowDom
 */
var focusInside = function (topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) { activeElement = getActiveElement(getFirst(topNode).ownerDocument); }
    if (!activeElement || (activeElement.dataset && activeElement.dataset.focusGuard)) {
        return false;
    }
    return getAllAffectedNodes(topNode).some(function (node) {
        return contains(node, activeElement) || focusInsideIframe(node, activeElement);
    });
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/commands.js
var focusOn = function (target, focusOptions) {
    if ('focus' in target) {
        target.focus(focusOptions);
    }
    if ('contentWindow' in target && target.contentWindow) {
        target.contentWindow.focus();
    }
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/correctFocus.js

var findSelectedRadio = function (node, nodes) {
    return nodes
        .filter(isRadioElement)
        .filter(function (el) { return el.name === node.name; })
        .filter(function (el) { return el.checked; })[0] || node;
};
var correctNode = function (node, nodes) {
    if (isRadioElement(node) && node.name) {
        return findSelectedRadio(node, nodes);
    }
    return node;
};
/**
 * giving a set of radio inputs keeps only selected (tabbable) ones
 * @param nodes
 */
var correctNodes = function (nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function (node) { return resultSet.add(correctNode(node, nodes)); });
    // using filter to support IE11
    return nodes.filter(function (node) { return resultSet.has(node); });
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/firstFocus.js

var pickFirstFocus = function (nodes) {
    if (nodes[0] && nodes.length > 1) {
        return correctNode(nodes[0], nodes);
    }
    return nodes[0];
};
var pickFocusable = function (nodes, index) {
    if (nodes.length > 1) {
        return nodes.indexOf(correctNode(nodes[index], nodes));
    }
    return index;
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/solver.js



var NEW_FOCUS = 'NEW_FOCUS';
/**
 * Main solver for the "find next focus" question
 * @param innerNodes
 * @param outerNodes
 * @param activeElement
 * @param lastNode
 * @returns {number|string|undefined|*}
 */
var newFocus = function (innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = isGuard(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
        return undefined;
    }
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = correctNodes(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = pickFocusable(innerNodes, 0);
    var returnLastNode = pickFocusable(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) {
        return NEW_FOCUS;
    }
    // old focus
    if (!indexDiff && lastNodeInside >= 0) {
        return lastNodeInside;
    }
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnLastNode;
    }
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnFirstNode;
    }
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
        return lastNodeInside;
    }
    // focus above lock
    if (activeIndex <= firstNodeIndex) {
        return returnLastNode;
    }
    // focus below lock
    if (activeIndex > lastNodeIndex) {
        return returnFirstNode;
    }
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) {
            return lastNodeInside;
        }
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/auto-focus.js



var findAutoFocused = function (autoFocusables) {
    return function (node) {
        var _a;
        var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return (
        // @ts-expect-error
        node.autofocus ||
            //
            (autofocus !== undefined && autofocus !== 'false') ||
            //
            autoFocusables.indexOf(node) >= 0);
    };
};
var pickAutofocus = function (nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) {
        return pickFirstFocus(autoFocusable);
    }
    return pickFirstFocus(filterAutoFocusable(orderedNodes));
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/parenting.js



var getParents = function (node, parents) {
    if (parents === void 0) { parents = []; }
    parents.push(node);
    if (node.parentNode) {
        getParents(node.parentNode.host || node.parentNode, parents);
    }
    return parents;
};
/**
 * finds a parent for both nodeA and nodeB
 * @param nodeA
 * @param nodeB
 * @returns {boolean|*}
 */
var getCommonParent = function (nodeA, nodeB) {
    var parentsA = getParents(nodeA);
    var parentsB = getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < parentsA.length; i += 1) {
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) {
            return currentParent;
        }
    }
    return false;
};
var getTopCommonParent = function (baseActiveElement, leftEntry, rightEntries) {
    var activeElements = asArray(baseActiveElement);
    var leftEntries = asArray(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function (entry) {
        topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function (subEntry) {
            var common = getCommonParent(activeElement, subEntry);
            if (common) {
                if (!topCommon || contains(common, topCommon)) {
                    topCommon = common;
                }
                else {
                    topCommon = getCommonParent(common, topCommon);
                }
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
/**
 * return list of nodes which are expected to be autofocused inside a given top nodes
 * @param entries
 * @param visibilityCache
 */
var allParentAutofocusables = function (entries, visibilityCache) {
    return entries.reduce(function (acc, node) { return acc.concat(parentAutofocusables(node, visibilityCache)); }, []);
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/focusSolver.js








var reorderNodes = function (srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function (entity) { return remap.set(entity.node, entity); });
    // remap to dstNodes
    return srcNodes.map(function (node) { return remap.get(node); }).filter(isDefined);
};
/**
 * contains the main logic of the `focus-lock` package.
 *
 * ! you probably dont need this function !
 *
 * given top node(s) and the last active element returns the element to be focused next
 * @returns element which should be focused to move focus inside
 * @param topNode
 * @param lastNode
 */
var focusSolver = function (topNode, lastNode) {
    var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = getFocusableNodes(entries, visibilityCache);
    var innerElements = getTabbableNodes(entries, visibilityCache).filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) {
            return undefined;
        }
    }
    var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === NEW_FOCUS) {
        var focusNode = pickAutofocus(anyFocusable, innerNodes, allParentAutofocusables(entries, visibilityCache));
        if (focusNode) {
            return { node: focusNode };
        }
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) {
        return newId;
    }
    return orderedInnerElements[newId];
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/moveFocusInside.js


var guardCount = 0;
var lockDisabled = false;
/**
 * The main functionality of the focus-lock package
 *
 * Contains focus at a given node.
 * The last focused element will help to determine which element(first or last) should be focused.
 * The found element will be focused.
 *
 * This is one time action (move), not a persistent focus-lock
 *
 * HTML markers (see {@link import('./constants').FOCUS_AUTO} constants) can control autofocus
 * @see {@link focusSolver} for the same functionality without autofocus
 */
var moveFocusInside = function (topNode, lastNode, options) {
    if (options === void 0) { options = {}; }
    var focusable = focusSolver(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if (lockDisabled) {
        return;
    }
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/
        if (guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' +
                'See https://github.com/theKashey/focus-lock/#focus-fighting');
            lockDisabled = true;
            setTimeout(function () {
                lockDisabled = false;
            }, 1);
            return;
        }
        guardCount++;
        focusOn(focusable.node, options.focusOptions);
        guardCount--;
    }
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/focusables.js




/**
 * @returns list of focusable elements inside a given top node
 * @see {@link getFocusableNodes} for lower level access
 */
var expandFocusableNodes = function (topNode) {
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = getTabbableNodes([commonParent], visibilityCache, true);
    var innerElements = getTabbableNodes(entries, visibilityCache)
        .filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    })
        .map(function (_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function (_a) {
        var node = _a.node, index = _a.index;
        return ({
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: isGuard(node),
        });
    });
};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-focus-lock@2.9.6_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-focus-lock/dist/es2015/util.js
function deferAction(action) {
  setTimeout(action, 1);
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-focus-lock@2.9.6_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-focus-lock/dist/es2015/Trap.js
/* eslint-disable no-mixed-operators */







var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    // with cross frame return true for any value
    return Boolean(focusWasOutsideWindow);
  } // in other case return only of focus went a while aho


  return focusWasOutsideWindow === 'meanwhile';
};

var checkInHost = function checkInHost(check, el, boundary) {
  return el && ( // find host equal to active element and check nested active element
  el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) // dive up
  || el.parentNode && checkInHost(check, el.parentNode, boundary));
};

var withinHost = function withinHost(activeElement, workingArea) {
  return workingArea.some(function (area) {
    return checkInHost(activeElement, area, area);
  });
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus,
        shards = _lastActiveTrap.shards,
        crossFrame = _lastActiveTrap.crossFrame,
        focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !( // active element is "inside" working area
          focusInside(workingArea) || // check for shadow-dom contained elements
          activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              // Check if blur() exists, which is missing on certain elements on IE
              if (activeElement.blur) {
                activeElement.blur();
              }

              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions: focusOptions
              });
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = expandFocusableNodes(workingArea);
        var focusedIndex = allNodes.map(function (_ref) {
          var node = _ref.node;
          return node;
        }).indexOf(newActiveElement);

        if (focusedIndex > -1) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
                node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = function onBlur() {
  return deferAction(activateTrap);
};

var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/react.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};

FocusTrap.propTypes =  false ? 0 : {};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = 'just'; // using setTimeout to set  this variable after React/sidecar reaction

  deferAction(function () {
    focusWasOutsideWindow = 'meanwhile';
  });
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}

function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];

  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation(); // return focus only of last trap was removed

    if (!traps.filter(function (_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      // allow defer is no other trap is awaiting restore
      lastTrap.returnFocus(!trap);
    }
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap(true);
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
} // bind medium


mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function (cb) {
  return cb({
    moveFocusInside: moveFocusInside,
    focusInside: focusInside
  });
});
/* harmony default export */ const Trap = (index_es(reducePropsToState, handleStateChangeOnClient)(FocusWatcher));
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-focus-lock@2.9.6_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-focus-lock/dist/es2015/Combination.js





/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/

var FocusLockCombination = /*#__PURE__*/react.forwardRef(function FocusLockUICombination(props, ref) {
  return /*#__PURE__*/react.createElement(Lock, (0,esm_extends/* default */.Z)({
    sideCar: Trap,
    ref: ref
  }, props));
});

var _ref = Lock.propTypes || {},
    sideCar = _ref.sideCar,
    propTypes = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["sideCar"]);

FocusLockCombination.propTypes =  false ? 0 : {};
/* harmony default export */ const Combination = (FocusLockCombination);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-focus-lock@2.9.6_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-focus-lock/dist/es2015/index.js


/* harmony default export */ const es2015 = (Combination);

/***/ }),

/***/ 81779:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  yF: () => (/* binding */ UIDConsumer),
  Ot: () => (/* binding */ UIDReset)
});

// UNUSED EXPORTS: UIDFork

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/context.js + 1 modules
var context = __webpack_require__(65619);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/UIDComponent.js



// --------------------------------------------
var prefixId = function (id, prefix, name) {
    var uid = (prefix + id);
    return String(name ? name(uid) : uid);
};
/**
 * @deprecated
 * UID in form of renderProps (not SSR friendly)
 * @see https://github.com/thearnica/react-uid#react-components
 * @example
 * // get UID to connect label to input
 * <UID>
 *   {(id)} => <label htmlFor={id}><input id={id}/>}
 * </UID>
 *
 * // get uid to generate uid for a keys in a list
 * <UID>
 *   {(, uid)} => items.map(item => <li key={uid(item) />)}
 * </UID>
 */
var UID = /** @class */ (function (_super) {
    __extends(UID, _super);
    function UID() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            quartz: _this.props.idSource || context/* counter */.cL,
            prefix: (0,context/* getPrefix */.Gn)(_this.props.idSource),
            id: (0,context/* getId */.zv)(_this.props.idSource || context/* counter */.cL)
        };
        _this.uid = function (item) { return prefixId(_this.state.id + '-' + _this.state.quartz.uid(item), _this.state.prefix, _this.props.name); };
        return _this;
    }
    UID.prototype.render = function () {
        var _a = this.props, children = _a.children, name = _a.name;
        var _b = this.state, id = _b.id, prefix = _b.prefix;
        return children(prefixId(id, prefix, name), this.uid);
    };
    return UID;
}(react.Component));


;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/Control.js



/**
 * UID isolation component, required for SSR and testing.
 * Wrap your application with it to guarantee UID consistency between SSR and CSR.
 * @param {String} [prefix] - prefix for all generated ids
 * @example
 * <UIDReset>
 *    <App />
 * </UIDReset/>
 * @see https://github.com/thearnica/react-uid#server-side-friendly-uid
 */
var UIDReset = function (_a) {
    var children = _a.children, _b = _a.prefix, prefix = _b === void 0 ? '' : _b;
    return (react.createElement(context/* source */.qz.Provider, { value: (0,context/* createSource */._P)(prefix) }, children));
};
/**
 * Creates a sub-ids for nested components, isolating from inside a branch.
 * Useful for self-contained elements or code splitting
 * @see https://github.com/thearnica/react-uid#code-splitting
 */
var UIDFork = function (_a) {
    var children = _a.children, _b = _a.prefix, prefix = _b === void 0 ? '' : _b;
    return (React.createElement(UIDConsumer, null, function (id) { return (React.createElement(source.Provider, { value: createSource(id + '-' + prefix) }, children)); }));
};
/**
 * UID in form of renderProps. Supports nesting and SSR. Prefer {@link useUID} hook version if possible.
 * @see https://github.com/thearnica/react-uid#server-side-friendly-uid
 * @see https://github.com/thearnica/react-uid#react-components
 * @example
 * // get UID to connect label to input
 * <UIDConsumer>
 *   {(id)} => <label htmlFor={id}><input id={id}/>}
 * </UIDConsumer>
 *
 * // get uid to generate uid for a keys in a list
 * <UIDConsumer>
 *   {(, uid)} => items.map(item => <li key={uid(item) />)}
 * </UIDConsumer>
 *
 * @see {@link useUID} - a hook version of this component
 * @see {@link UID} - not SSR compatible version
 */
var UIDConsumer = function (_a) {
    var name = _a.name, children = _a.children;
    return (react.createElement(context/* source */.qz.Consumer, null, function (value) { return (react.createElement(UID, { name: name, idSource: value, children: children })); }));
};


/***/ }),

/***/ 65619:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  cL: () => (/* binding */ counter),
  _P: () => (/* binding */ createSource),
  zv: () => (/* binding */ getId),
  Gn: () => (/* binding */ getPrefix),
  qz: () => (/* binding */ source)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/uid.js
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */
var generateUID = function () {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */
    var uid = function (item, index) {
        if (typeof item === 'number' ||
            typeof item === 'string') {
            return index ? "idx-" + index : "val-" + item;
        }
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
/**
 * @name uid
 * returns an UID associated with {item}
 * @param {Object} item - object to generate UID for
 * @param {Number} index, a fallback index
 * @example
 * uid(object) == 1;
 * uid(object) == 1;
 * uid(anotherObject) == 2;
 * uid("not object", 42) == 42
 *
 * @see {@link useUID}
 */
var uid = generateUID();

;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/context.js


var createSource = function (prefix) {
    if (prefix === void 0) { prefix = ''; }
    return ({
        value: 1,
        prefix: prefix,
        uid: generateUID()
    });
};
var counter = createSource();
var source = react.createContext(createSource());
var getId = function (source) { return source.value++; };
var getPrefix = function (source) { return source ? source.prefix : ''; };


/***/ }),

/***/ 4689:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ useUID),
/* harmony export */   H: () => (/* binding */ useUIDSeed)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65619);


var generateUID = function (context) {
    var quartz = context || _context__WEBPACK_IMPORTED_MODULE_1__/* .counter */ .cL;
    var prefix = (0,_context__WEBPACK_IMPORTED_MODULE_1__/* .getPrefix */ .Gn)(quartz);
    var id = (0,_context__WEBPACK_IMPORTED_MODULE_1__/* .getId */ .zv)(quartz);
    var uid = prefix + id;
    var gen = function (item) { return uid + quartz.uid(item); };
    return { uid: uid, gen: gen };
};
var useUIDState = function () {
    if (false) {}
    // @ts-ignore
    return react__WEBPACK_IMPORTED_MODULE_0__.useState(generateUID(react__WEBPACK_IMPORTED_MODULE_0__.useContext(_context__WEBPACK_IMPORTED_MODULE_1__/* .source */ .qz)));
};
/**
 * returns and unique id. SSR friendly
 * returns {String}
 * @see {@link UIDConsumer}
 * @see https://github.com/thearnica/react-uid#hooks-168
 * @example
 * const id = useUID();
 * id == 1; // for example
 */
var useUID = function () {
    var uid = useUIDState()[0].uid;
    return uid;
};
/**
 * returns an uid generator
 * @see {@link UIDConsumer}
 * @see https://github.com/thearnica/react-uid#hooks-168
 * @example
 * const uid = useUIDSeed();
 * return (
 *  <>
 *    <label for={seed('email')}>Email: </label>
 *    <input id={seed('email')} name="email" />
 *    {data.map(item => <div key={seed(item)}>...</div>
 *  </>
 * )
 */
var useUIDSeed = function () {
    var gen = useUIDState()[0].gen;
    return gen;
};


/***/ }),

/***/ 7085:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ client)
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/styletron-engine-monolithic@1.0.0/node_modules/styletron-engine-monolithic/dist-browser-esm/client/sheet.js
/* eslint-env browser */

/*
pretty much vendored @emotion/sheet
Based off glamor's StyleSheet, thanks Sunil ❤️
high performance StyleSheet for css-in-js systems
- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
// usage
import { StyleSheet } from '@emotion/sheet'
let styleSheet = new StyleSheet({ container: document.head })
styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet
styleSheet.flush()
- empties the stylesheet of all its contents
*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (let i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  const tag = document.createElement("style");

  if (typeof options.nonce !== "undefined") {
    tag.setAttribute("nonce", options.nonce);
  }

  tag.appendChild(document.createTextNode(""));
  return tag;
}

class StyleSheet {
  constructor(options) {
    this.isSpeedy = typeof options.speedy === "undefined" ? !("production" !== "production") : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.container = options.container;
    this.before = null;
  }

  insert(rules) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      const tag = createStyleElement(this);
      let before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(tag, before);
      this.tags.push(tag);
    }

    const tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      const sheet = sheetForTag(tag);
      rules.forEach(rule => {
        try {
          // this is the ultrafast version, works across browsers
          // the big drawback is that the css won't be editable in devtools
          sheet.insertRule(rule, sheet.cssRules.length);
        } catch (e) {
          if (false) {}
        }
      });
    } else {
      tag.appendChild(document.createTextNode(rules.join("")));
    }

    this.ctr++;
  }

  flush() {
    // $FlowFixMe
    this.tags.forEach(tag => tag.parentNode.removeChild(tag));
    this.tags = [];
    this.ctr = 0;
  }

}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
// EXTERNAL MODULE: ../../node_modules/.pnpm/styletron-engine-monolithic@1.0.0/node_modules/styletron-engine-monolithic/dist-browser-esm/inject-style-prefixed.js + 21 modules
var inject_style_prefixed = __webpack_require__(1693);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styletron-engine-monolithic@1.0.0/node_modules/styletron-engine-monolithic/dist-browser-esm/css.js + 2 modules
var css = __webpack_require__(78736);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/styletron-engine-monolithic@1.0.0/node_modules/styletron-engine-monolithic/dist-browser-esm/client/client.js
/* eslint-env browser */




class StyletronClient {
  constructor(opts = {}) {
    this.opts = opts || {};
    this.cache = {};

    if (opts.container) {
      this.container = opts.container;
    } // hydration


    if (opts.hydrate && opts.hydrate.length > 1) {
      if (false) {}
    } else if (opts.hydrate && opts.hydrate.length === 1) {
      // infer container from parent element
      if (!this.container) {
        const parentElement = opts.hydrate[0].parentElement;

        if (parentElement !== null && parentElement !== void 0) {
          this.container = parentElement;
        }
      } // there is a single style tag coming from the monolithic server


      const element = opts.hydrate[0];
      const dataHydrate = element.getAttribute("data-hydrate");

      if (dataHydrate) {
        dataHydrate.split(" ").forEach(hashKey => {
          // cache keys are unique across fonts, keyframes and other css so
          // we use a single attribute to get them all
          this.cache[hashKey] = true;
        });
      }
    }

    if (!this.container) {
      if (document.head === null) {
        throw new Error("No container provided and `document.head` was null");
      }

      this.container = document.head;
    }

    this.styleSheet = new StyleSheet({
      container: this.container,
      speedy: this.opts.speedy
    });
  }

  renderStyle(styles) {
    const className = (0,css/* hashCssObject */.Ab)(styles);

    if (!this.cache[className]) {
      this.cache[className] = true;
      this.styleSheet.insert((0,inject_style_prefixed/* default */.Z)(styles, className, this.opts.prefix || "", Boolean(this.opts.strict)));
    }

    return `${this.opts.prefix || ""}css-${className}`;
  }

  renderFontFace(fontFace) {
    const fontName = (0,css/* hashCssObject */.Ab)(fontFace);

    if (!this.cache[fontName]) {
      this.cache[fontName] = true;
      this.styleSheet.insert([(0,css/* fontFaceBlockToRule */.cE)(`${this.opts.prefix || ""}font-${fontName}`, (0,css/* declarationsToBlock */.Rk)(fontFace))]);
    }

    return `${this.opts.prefix || ""}font-${fontName}`;
  }

  renderKeyframes(keyframes) {
    const animationName = (0,css/* hashCssObject */.Ab)(keyframes);

    if (!this.cache[animationName]) {
      this.cache[animationName] = true;
      this.styleSheet.insert([(0,css/* keyframesBlockToRule */.Rs)(`${this.opts.prefix || ""}animation-${animationName}`, (0,css/* keyframesToBlock */.B4)(keyframes))]);
    }

    return `${this.opts.prefix || ""}animation-${animationName}`;
  }

}

/* harmony default export */ const client = (StyletronClient);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 78736:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Rk: () => (/* binding */ declarationsToBlock),
  cE: () => (/* binding */ fontFaceBlockToRule),
  Ab: () => (/* binding */ hashCssObject),
  Rs: () => (/* binding */ keyframesBlockToRule),
  B4: () => (/* binding */ keyframesToBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/styletron-engine-monolithic@1.0.0/node_modules/styletron-engine-monolithic/dist-browser-esm/hyphenate-style-name.js
var hyphenate_style_name = __webpack_require__(99136);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/styletron-engine-monolithic@1.0.0/node_modules/styletron-engine-monolithic/dist-browser-esm/generate-alphabetic-name.js
// vendored in from styled-components
const AD_REPLACER_R = /(a)(d)/gi;
/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */

const charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */

const getAlphabeticChar = code => String.fromCharCode(code + (code > 25 ? 39 : 97));
/* input a number, usually a hash and convert it to base-52 */


function generateAlphabeticName(code) {
  let name = "";
  let x;
  /* get a char and divide by alphabet-length */

  for (x = Math.abs(code); x > charsLength; x = x / charsLength | 0) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return (getAlphabeticChar(x % charsLength) + name).replace(AD_REPLACER_R, "$1-$2");
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
;// CONCATENATED MODULE: ../../node_modules/.pnpm/styletron-engine-monolithic@1.0.0/node_modules/styletron-engine-monolithic/dist-browser-esm/hash.js
// vendored in from styled-components
const SEED = 5381 | 0; // When we have separate strings it's useful to run a progressive
// version of djb2 where we pretend that we're still looping over
// the same string

const phash = (h, x) => {
  h |= 0;

  for (let i = 0, l = x.length | 0; i < l; i++) {
    h = (h << 5) + h + x.charCodeAt(i);
  }

  return h;
}; // This is a djb2 hashing function

const hash = x => {
  return phash(SEED, x) >>> 0;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRUVEIiwicGhhc2giLCJoIiwieCIsImkiLCJsIiwibGVuZ3RoIiwiY2hhckNvZGVBdCIsImhhc2giXSwic291cmNlcyI6WyJzcmMvaGFzaC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIvLyB2ZW5kb3JlZCBpbiBmcm9tIHN0eWxlZC1jb21wb25lbnRzXG5cbmV4cG9ydCBjb25zdCBTRUVEID0gNTM4MSB8IDA7XG5cbi8vIFdoZW4gd2UgaGF2ZSBzZXBhcmF0ZSBzdHJpbmdzIGl0J3MgdXNlZnVsIHRvIHJ1biBhIHByb2dyZXNzaXZlXG4vLyB2ZXJzaW9uIG9mIGRqYjIgd2hlcmUgd2UgcHJldGVuZCB0aGF0IHdlJ3JlIHN0aWxsIGxvb3Bpbmcgb3ZlclxuLy8gdGhlIHNhbWUgc3RyaW5nXG5leHBvcnQgY29uc3QgcGhhc2ggPSAoaDogbnVtYmVyLCB4OiBzdHJpbmcpOiBudW1iZXIgPT4ge1xuICBoIHw9IDA7XG4gIGZvciAobGV0IGkgPSAwLCBsID0geC5sZW5ndGggfCAwOyBpIDwgbDsgaSsrKSB7XG4gICAgaCA9IChoIDw8IDUpICsgaCArIHguY2hhckNvZGVBdChpKTtcbiAgfVxuXG4gIHJldHVybiBoO1xufTtcblxuLy8gVGhpcyBpcyBhIGRqYjIgaGFzaGluZyBmdW5jdGlvblxuZXhwb3J0IGNvbnN0IGhhc2ggPSAoeDogc3RyaW5nKTogbnVtYmVyID0+IHtcbiAgcmV0dXJuIHBoYXNoKFNFRUQsIHgpID4+PiAwO1xufTtcbiJdLCJtYXBwaW5ncyI6IkFBQUE7QUFFQSxPQUFPLE1BQU1BLElBQUksR0FBRyxPQUFPLENBQXBCLEMsQ0FFUDtBQUNBO0FBQ0E7O0FBQ0EsT0FBTyxNQUFNQyxLQUFLLEdBQUcsQ0FBQ0MsQ0FBRCxFQUFZQyxDQUFaLEtBQWtDO0VBQ3JERCxDQUFDLElBQUksQ0FBTDs7RUFDQSxLQUFLLElBQUlFLENBQUMsR0FBRyxDQUFSLEVBQVdDLENBQUMsR0FBR0YsQ0FBQyxDQUFDRyxNQUFGLEdBQVcsQ0FBL0IsRUFBa0NGLENBQUMsR0FBR0MsQ0FBdEMsRUFBeUNELENBQUMsRUFBMUMsRUFBOEM7SUFDNUNGLENBQUMsR0FBRyxDQUFDQSxDQUFDLElBQUksQ0FBTixJQUFXQSxDQUFYLEdBQWVDLENBQUMsQ0FBQ0ksVUFBRixDQUFhSCxDQUFiLENBQW5CO0VBQ0Q7O0VBRUQsT0FBT0YsQ0FBUDtBQUNELENBUE0sQyxDQVNQOztBQUNBLE9BQU8sTUFBTU0sSUFBSSxHQUFJTCxDQUFELElBQXVCO0VBQ3pDLE9BQU9GLEtBQUssQ0FBQ0QsSUFBRCxFQUFPRyxDQUFQLENBQUwsS0FBbUIsQ0FBMUI7QUFDRCxDQUZNIn0=
;// CONCATENATED MODULE: ../../node_modules/.pnpm/styletron-engine-monolithic@1.0.0/node_modules/styletron-engine-monolithic/dist-browser-esm/css.js




function hashCssObject(cssObject) {
  return generateAlphabeticName(hash(JSON.stringify(cssObject)));
}
function keyframesToBlock(keyframes) {
  if (false) {}

  if (false) {}

  let result = "";

  for (const animationState in keyframes) {
    result += `${animationState}{${declarationsToBlock(keyframes[animationState])}}`;
  }

  return result;
}
function declarationsToBlock(style) {
  let css = "";

  for (const prop in style) {
    const val = style[prop];

    if (typeof val === "string" || typeof val === "number") {
      css += `${(0,hyphenate_style_name/* default */.Z)(prop)}:${val};`;
    }
  } // trim trailing semicolon


  return css.slice(0, -1);
}
function keyframesBlockToRule(id, block) {
  return `@keyframes ${id}{${block}}`;
}
function fontFaceBlockToRule(id, block) {
  return `@font-face{font-family:${id};${block}}`;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJoeXBoZW5hdGUiLCJ2YWxpZGF0ZUtleWZyYW1lc09iamVjdCIsImdlbmVyYXRlQWxwaGFiZXRpY05hbWUiLCJoYXNoIiwiaGFzaENzc09iamVjdCIsImNzc09iamVjdCIsIkpTT04iLCJzdHJpbmdpZnkiLCJrZXlmcmFtZXNUb0Jsb2NrIiwia2V5ZnJhbWVzIiwiT2JqZWN0IiwiZ2V0UHJvdG90eXBlT2YiLCJjb25zb2xlIiwid2FybiIsInJlc3VsdCIsImFuaW1hdGlvblN0YXRlIiwiZGVjbGFyYXRpb25zVG9CbG9jayIsInN0eWxlIiwiY3NzIiwicHJvcCIsInZhbCIsInNsaWNlIiwia2V5ZnJhbWVzQmxvY2tUb1J1bGUiLCJpZCIsImJsb2NrIiwiZm9udEZhY2VCbG9ja1RvUnVsZSJdLCJzb3VyY2VzIjpbInNyYy9jc3MudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZGVjbGFyZSB2YXIgX19ERVZfXzogYm9vbGVhbjtcblxuaW1wb3J0IGh5cGhlbmF0ZSBmcm9tIFwiLi9oeXBoZW5hdGUtc3R5bGUtbmFtZVwiO1xuaW1wb3J0IHZhbGlkYXRlS2V5ZnJhbWVzT2JqZWN0IGZyb20gXCIuL3ZhbGlkYXRlLWtleWZyYW1lcy1vYmplY3RcIjtcbmltcG9ydCBnZW5lcmF0ZUFscGhhYmV0aWNOYW1lIGZyb20gXCIuL2dlbmVyYXRlLWFscGhhYmV0aWMtbmFtZVwiO1xuaW1wb3J0IHtoYXNofSBmcm9tIFwiLi9oYXNoXCI7XG5cbmltcG9ydCB0eXBlIHtcbiAgU3R5bGVPYmplY3QsXG4gIEZvbnRGYWNlT2JqZWN0LFxuICBLZXlmcmFtZXNPYmplY3QsXG59IGZyb20gXCJzdHlsZXRyb24tc3RhbmRhcmRcIjtcblxuZXhwb3J0IGZ1bmN0aW9uIGhhc2hDc3NPYmplY3QoXG4gIGNzc09iamVjdDogU3R5bGVPYmplY3QgfCBGb250RmFjZU9iamVjdCB8IEtleWZyYW1lc09iamVjdCxcbik6IHN0cmluZyB7XG4gIHJldHVybiBnZW5lcmF0ZUFscGhhYmV0aWNOYW1lKGhhc2goSlNPTi5zdHJpbmdpZnkoY3NzT2JqZWN0KSkpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24ga2V5ZnJhbWVzVG9CbG9jayhrZXlmcmFtZXM6IHtbeDogc3RyaW5nXTogYW55fSk6IHN0cmluZyB7XG4gIGlmIChfX0RFVl9fKSB7XG4gICAgdmFsaWRhdGVLZXlmcmFtZXNPYmplY3Qoa2V5ZnJhbWVzKTtcbiAgfVxuICBpZiAoX19ERVZfXyAmJiB0eXBlb2YgT2JqZWN0LmdldFByb3RvdHlwZU9mKGtleWZyYW1lcykgIT09IFwidW5kZWZpbmVkXCIpIHtcbiAgICBpZiAoT2JqZWN0LmdldFByb3RvdHlwZU9mKGtleWZyYW1lcykgIT09IE9iamVjdC5nZXRQcm90b3R5cGVPZih7fSkpIHtcbiAgICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBuby1jb25zb2xlXG4gICAgICBjb25zb2xlLndhcm4oXG4gICAgICAgIFwiT25seSBwbGFpbiBvYmplY3RzIHNob3VsZCBiZSB1c2VkIGFzIGFuaW1hdGlvbiB2YWx1ZXMuIFVuZXhwZWN0ZWRseSByZWNpZXZlZDpcIixcbiAgICAgICAga2V5ZnJhbWVzLFxuICAgICAgKTtcbiAgICB9XG4gIH1cbiAgbGV0IHJlc3VsdCA9IFwiXCI7XG4gIGZvciAoY29uc3QgYW5pbWF0aW9uU3RhdGUgaW4ga2V5ZnJhbWVzKSB7XG4gICAgcmVzdWx0ICs9IGAke2FuaW1hdGlvblN0YXRlfXske2RlY2xhcmF0aW9uc1RvQmxvY2soXG4gICAgICBrZXlmcmFtZXNbYW5pbWF0aW9uU3RhdGVdLFxuICAgICl9fWA7XG4gIH1cbiAgcmV0dXJuIHJlc3VsdDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGRlY2xhcmF0aW9uc1RvQmxvY2soc3R5bGU6IGFueSk6IHN0cmluZyB7XG4gIGxldCBjc3MgPSBcIlwiO1xuICBmb3IgKGNvbnN0IHByb3AgaW4gc3R5bGUpIHtcbiAgICBjb25zdCB2YWwgPSBzdHlsZVtwcm9wXTtcbiAgICBpZiAodHlwZW9mIHZhbCA9PT0gXCJzdHJpbmdcIiB8fCB0eXBlb2YgdmFsID09PSBcIm51bWJlclwiKSB7XG4gICAgICBjc3MgKz0gYCR7aHlwaGVuYXRlKHByb3ApfToke3ZhbH07YDtcbiAgICB9XG4gIH1cbiAgLy8gdHJpbSB0cmFpbGluZyBzZW1pY29sb25cbiAgcmV0dXJuIGNzcy5zbGljZSgwLCAtMSk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBrZXlmcmFtZXNCbG9ja1RvUnVsZShpZDogc3RyaW5nLCBibG9jazogc3RyaW5nKTogc3RyaW5nIHtcbiAgcmV0dXJuIGBAa2V5ZnJhbWVzICR7aWR9eyR7YmxvY2t9fWA7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBmb250RmFjZUJsb2NrVG9SdWxlKGlkOiBzdHJpbmcsIGJsb2NrOiBzdHJpbmcpOiBzdHJpbmcge1xuICByZXR1cm4gYEBmb250LWZhY2V7Zm9udC1mYW1pbHk6JHtpZH07JHtibG9ja319YDtcbn1cbiJdLCJtYXBwaW5ncyI6IkFBRUEsT0FBT0EsU0FBUCxNQUFzQix3QkFBdEI7QUFDQSxPQUFPQyx1QkFBUCxNQUFvQyw2QkFBcEM7QUFDQSxPQUFPQyxzQkFBUCxNQUFtQyw0QkFBbkM7QUFDQSxTQUFRQyxJQUFSLFFBQW1CLFFBQW5CO0FBUUEsT0FBTyxTQUFTQyxhQUFULENBQ0xDLFNBREssRUFFRztFQUNSLE9BQU9ILHNCQUFzQixDQUFDQyxJQUFJLENBQUNHLElBQUksQ0FBQ0MsU0FBTCxDQUFlRixTQUFmLENBQUQsQ0FBTCxDQUE3QjtBQUNEO0FBRUQsT0FBTyxTQUFTRyxnQkFBVCxDQUEwQkMsU0FBMUIsRUFBaUU7RUFDdEUsMkNBQWE7SUFDWFIsdUJBQXVCLENBQUNRLFNBQUQsQ0FBdkI7RUFDRDs7RUFDRCxJQUFJLHlDQUFXLE9BQU9DLE1BQU0sQ0FBQ0MsY0FBUCxDQUFzQkYsU0FBdEIsQ0FBUCxLQUE0QyxXQUEzRCxFQUF3RTtJQUN0RSxJQUFJQyxNQUFNLENBQUNDLGNBQVAsQ0FBc0JGLFNBQXRCLE1BQXFDQyxNQUFNLENBQUNDLGNBQVAsQ0FBc0IsRUFBdEIsQ0FBekMsRUFBb0U7TUFDbEU7TUFDQUMsT0FBTyxDQUFDQyxJQUFSLENBQ0UsK0VBREYsRUFFRUosU0FGRjtJQUlEO0VBQ0Y7O0VBQ0QsSUFBSUssTUFBTSxHQUFHLEVBQWI7O0VBQ0EsS0FBSyxNQUFNQyxjQUFYLElBQTZCTixTQUE3QixFQUF3QztJQUN0Q0ssTUFBTSxJQUFLLEdBQUVDLGNBQWUsSUFBR0MsbUJBQW1CLENBQ2hEUCxTQUFTLENBQUNNLGNBQUQsQ0FEdUMsQ0FFaEQsR0FGRjtFQUdEOztFQUNELE9BQU9ELE1BQVA7QUFDRDtBQUVELE9BQU8sU0FBU0UsbUJBQVQsQ0FBNkJDLEtBQTdCLEVBQWlEO0VBQ3RELElBQUlDLEdBQUcsR0FBRyxFQUFWOztFQUNBLEtBQUssTUFBTUMsSUFBWCxJQUFtQkYsS0FBbkIsRUFBMEI7SUFDeEIsTUFBTUcsR0FBRyxHQUFHSCxLQUFLLENBQUNFLElBQUQsQ0FBakI7O0lBQ0EsSUFBSSxPQUFPQyxHQUFQLEtBQWUsUUFBZixJQUEyQixPQUFPQSxHQUFQLEtBQWUsUUFBOUMsRUFBd0Q7TUFDdERGLEdBQUcsSUFBSyxHQUFFbEIsU0FBUyxDQUFDbUIsSUFBRCxDQUFPLElBQUdDLEdBQUksR0FBakM7SUFDRDtFQUNGLENBUHFELENBUXREOzs7RUFDQSxPQUFPRixHQUFHLENBQUNHLEtBQUosQ0FBVSxDQUFWLEVBQWEsQ0FBQyxDQUFkLENBQVA7QUFDRDtBQUVELE9BQU8sU0FBU0Msb0JBQVQsQ0FBOEJDLEVBQTlCLEVBQTBDQyxLQUExQyxFQUFpRTtFQUN0RSxPQUFRLGNBQWFELEVBQUcsSUFBR0MsS0FBTSxHQUFqQztBQUNEO0FBRUQsT0FBTyxTQUFTQyxtQkFBVCxDQUE2QkYsRUFBN0IsRUFBeUNDLEtBQXpDLEVBQWdFO0VBQ3JFLE9BQVEsMEJBQXlCRCxFQUFHLElBQUdDLEtBQU0sR0FBN0M7QUFDRCJ9

/***/ }),

/***/ 99136:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ hyphenateStyleName)
/* harmony export */ });
const uppercasePattern = /[A-Z]/g;
const msPattern = /^ms-/;
const cache = {};
function hyphenateStyleName(prop) {
  return prop in cache ? cache[prop] : cache[prop] = prop.replace(uppercasePattern, "-$&").toLowerCase().replace(msPattern, "-ms-");
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1cHBlcmNhc2VQYXR0ZXJuIiwibXNQYXR0ZXJuIiwiY2FjaGUiLCJoeXBoZW5hdGVTdHlsZU5hbWUiLCJwcm9wIiwicmVwbGFjZSIsInRvTG93ZXJDYXNlIl0sInNvdXJjZXMiOlsic3JjL2h5cGhlbmF0ZS1zdHlsZS1uYW1lLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHVwcGVyY2FzZVBhdHRlcm4gPSAvW0EtWl0vZztcbmNvbnN0IG1zUGF0dGVybiA9IC9ebXMtLztcbmNvbnN0IGNhY2hlID0ge307XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGh5cGhlbmF0ZVN0eWxlTmFtZShwcm9wOiBzdHJpbmcpOiBzdHJpbmcge1xuICByZXR1cm4gcHJvcCBpbiBjYWNoZVxuICAgID8gY2FjaGVbcHJvcF1cbiAgICA6IChjYWNoZVtwcm9wXSA9IHByb3BcbiAgICAgICAgLnJlcGxhY2UodXBwZXJjYXNlUGF0dGVybiwgXCItJCZcIilcbiAgICAgICAgLnRvTG93ZXJDYXNlKClcbiAgICAgICAgLnJlcGxhY2UobXNQYXR0ZXJuLCBcIi1tcy1cIikpO1xufVxuIl0sIm1hcHBpbmdzIjoiQUFBQSxNQUFNQSxnQkFBZ0IsR0FBRyxRQUF6QjtBQUNBLE1BQU1DLFNBQVMsR0FBRyxNQUFsQjtBQUNBLE1BQU1DLEtBQUssR0FBRyxFQUFkO0FBRUEsZUFBZSxTQUFTQyxrQkFBVCxDQUE0QkMsSUFBNUIsRUFBa0Q7RUFDL0QsT0FBT0EsSUFBSSxJQUFJRixLQUFSLEdBQ0hBLEtBQUssQ0FBQ0UsSUFBRCxDQURGLEdBRUZGLEtBQUssQ0FBQ0UsSUFBRCxDQUFMLEdBQWNBLElBQUksQ0FDaEJDLE9BRFksQ0FDSkwsZ0JBREksRUFDYyxLQURkLEVBRVpNLFdBRlksR0FHWkQsT0FIWSxDQUdKSixTQUhJLEVBR08sTUFIUCxDQUZuQjtBQU1EIn0=

/***/ }),

/***/ 1693:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ injectStylePrefixed)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/styletron-engine-monolithic@1.0.0/node_modules/styletron-engine-monolithic/dist-browser-esm/hyphenate-style-name.js
var hyphenate_style_name = __webpack_require__(99136);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/utils/capitalizeString.js
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/utils/prefixProperty.js



function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = capitalizeString(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/utils/prefixValue.js
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/utils/addNewValuesOnly.js
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/utils/isObject.js
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/createPrefixer.js






function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  return function prefix(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if (isObject(value)) {
        style[property] = prefix(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = prefixValue(plugins, property, value[i], style, prefixMap);
          addNewValuesOnly(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = prefixValue(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = prefixProperty(prefixMap, property, style);
      }
    }

    return style;
  };
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/data.js

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

/* harmony default export */ const data = ({
  plugins: [],
  prefixMap: { "appearance": wm, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "userSelect": wmms, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "clipPath": w, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "filter": w, "hyphens": wms, "flowInto": wms, "flowFrom": wms, "breakBefore": wms, "breakAfter": wms, "breakInside": wms, "regionFragment": wms, "writingMode": wms, "textOrientation": w, "tabSize": m, "fontFeatureSettings": w, "columnCount": w, "columnFill": w, "columnGap": w, "columnRule": w, "columnRuleColor": w, "columnRuleStyle": w, "columnRuleWidth": w, "columns": w, "columnSpan": w, "columnWidth": w, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "textSizeAdjust": wms }
});
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/backgroundClip.js

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/cursor.js
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/css-in-js-utils@2.0.1/node_modules/css-in-js-utils/lib/isPrefixedValue.js
var isPrefixedValue = __webpack_require__(36107);
var isPrefixedValue_default = /*#__PURE__*/__webpack_require__.n(isPrefixedValue);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/crossFade.js


// http://caniuse.com/#search=cross-fade
var crossFade_prefixes = ['-webkit-', ''];

function crossFade(property, value) {
  if (typeof value === 'string' && !isPrefixedValue_default()(value) && value.indexOf('cross-fade(') > -1) {
    return crossFade_prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/filter.js


// http://caniuse.com/#feat=css-filter-function
var filter_prefixes = ['-webkit-', ''];

function filter(property, value) {
  if (typeof value === 'string' && !isPrefixedValue_default()(value) && value.indexOf('filter(') > -1) {
    return filter_prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/flex.js
var flex_values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && flex_values.hasOwnProperty(value)) {
    return flex_values[value];
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/flexboxOld.js
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/gradient.js


var gradient_prefixes = ['-webkit-', '-moz-', ''];
var gradient_values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !isPrefixedValue_default()(value) && gradient_values.test(value)) {
    return gradient_prefixes.map(function (prefix) {
      return value.replace(gradient_values, function (grad) {
        return prefix + grad;
      });
    });
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/grid.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function isSimplePositionValue(value) {
  return typeof value === 'number' && !isNaN(value);
}

function isComplexSpanValue(value) {
  return typeof value === 'string' && value.includes('/');
}

var alignmentValues = ['center', 'end', 'start', 'stretch'];

var displayValues = {
  'inline-grid': ['-ms-inline-grid', 'inline-grid'],
  grid: ['-ms-grid', 'grid']
};

var propertyConverters = {
  alignSelf: function alignSelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridRowAlign = value;
    }
  },

  gridColumn: function gridColumn(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    } else if (isComplexSpanValue(value)) {
      var _value$split = value.split('/'),
          _value$split2 = _slicedToArray(_value$split, 2),
          start = _value$split2[0],
          end = _value$split2[1];

      propertyConverters.gridColumnStart(+start, style);

      var _end$split = end.split(/ ?span /),
          _end$split2 = _slicedToArray(_end$split, 2),
          maybeSpan = _end$split2[0],
          maybeNumber = _end$split2[1];

      if (maybeSpan === '') {
        propertyConverters.gridColumnEnd(+start + +maybeNumber, style);
      } else {
        propertyConverters.gridColumnEnd(+end, style);
      }
    } else {
      propertyConverters.gridColumnStart(value, style);
    }
  },

  gridColumnEnd: function gridColumnEnd(value, style) {
    var msGridColumn = style.msGridColumn;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridColumn)) {
      style.msGridColumnSpan = value - msGridColumn;
    }
  },

  gridColumnStart: function gridColumnStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    }
  },

  gridRow: function gridRow(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    } else if (isComplexSpanValue(value)) {
      var _value$split3 = value.split('/'),
          _value$split4 = _slicedToArray(_value$split3, 2),
          start = _value$split4[0],
          end = _value$split4[1];

      propertyConverters.gridRowStart(+start, style);

      var _end$split3 = end.split(/ ?span /),
          _end$split4 = _slicedToArray(_end$split3, 2),
          maybeSpan = _end$split4[0],
          maybeNumber = _end$split4[1];

      if (maybeSpan === '') {
        propertyConverters.gridRowEnd(+start + +maybeNumber, style);
      } else {
        propertyConverters.gridRowEnd(+end, style);
      }
    } else {
      propertyConverters.gridRowStart(value, style);
    }
  },

  gridRowEnd: function gridRowEnd(value, style) {
    var msGridRow = style.msGridRow;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridRow)) {
      style.msGridRowSpan = value - msGridRow;
    }
  },

  gridRowStart: function gridRowStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    }
  },

  gridTemplateColumns: function gridTemplateColumns(value, style) {
    style.msGridColumns = value;
  },

  gridTemplateRows: function gridTemplateRows(value, style) {
    style.msGridRows = value;
  },

  justifySelf: function justifySelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridColumnAlign = value;
    }
  }
};

function grid(property, value, style) {
  if (property === 'display' && value in displayValues) {
    return displayValues[value];
  }

  if (property in propertyConverters) {
    var propertyConverter = propertyConverters[property];
    propertyConverter(value, style);
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/imageSet.js


// http://caniuse.com/#feat=css-image-set
var imageSet_prefixes = ['-webkit-', ''];

function imageSet(property, value) {
  if (typeof value === 'string' && !isPrefixedValue_default()(value) && value.indexOf('image-set(') > -1) {
    return imageSet_prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/logical.js
var logical_alternativeProps = {
  marginBlockStart: ['WebkitMarginBefore'],
  marginBlockEnd: ['WebkitMarginAfter'],
  marginInlineStart: ['WebkitMarginStart', 'MozMarginStart'],
  marginInlineEnd: ['WebkitMarginEnd', 'MozMarginEnd'],
  paddingBlockStart: ['WebkitPaddingBefore'],
  paddingBlockEnd: ['WebkitPaddingAfter'],
  paddingInlineStart: ['WebkitPaddingStart', 'MozPaddingStart'],
  paddingInlineEnd: ['WebkitPaddingEnd', 'MozPaddingEnd'],
  borderBlockStart: ['WebkitBorderBefore'],
  borderBlockStartColor: ['WebkitBorderBeforeColor'],
  borderBlockStartStyle: ['WebkitBorderBeforeStyle'],
  borderBlockStartWidth: ['WebkitBorderBeforeWidth'],
  borderBlockEnd: ['WebkitBorderAfter'],
  borderBlockEndColor: ['WebkitBorderAfterColor'],
  borderBlockEndStyle: ['WebkitBorderAfterStyle'],
  borderBlockEndWidth: ['WebkitBorderAfterWidth'],
  borderInlineStart: ['WebkitBorderStart', 'MozBorderStart'],
  borderInlineStartColor: ['WebkitBorderStartColor', 'MozBorderStartColor'],
  borderInlineStartStyle: ['WebkitBorderStartStyle', 'MozBorderStartStyle'],
  borderInlineStartWidth: ['WebkitBorderStartWidth', 'MozBorderStartWidth'],
  borderInlineEnd: ['WebkitBorderEnd', 'MozBorderEnd'],
  borderInlineEndColor: ['WebkitBorderEndColor', 'MozBorderEndColor'],
  borderInlineEndStyle: ['WebkitBorderEndStyle', 'MozBorderEndStyle'],
  borderInlineEndWidth: ['WebkitBorderEndWidth', 'MozBorderEndWidth']
};

function logical(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(logical_alternativeProps, property)) {
    var alternativePropList = logical_alternativeProps[property];
    for (var i = 0, len = alternativePropList.length; i < len; ++i) {
      style[alternativePropList[i]] = value;
    }
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/position.js
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/sizing.js
var sizing_prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var sizing_values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && sizing_values.hasOwnProperty(value)) {
    return sizing_prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/css-in-js-utils@2.0.1/node_modules/css-in-js-utils/lib/hyphenateProperty.js
var hyphenateProperty = __webpack_require__(59528);
var hyphenateProperty_default = /*#__PURE__*/__webpack_require__.n(hyphenateProperty);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/plugins/transition.js





var transition_properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};

var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function transition_prefixValue(value, propertyPrefixMap) {
  if (isPrefixedValue_default()(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = hyphenateProperty_default()(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && transition_properties.hasOwnProperty(property)) {
    var outputValue = transition_prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + capitalizeString(property)] = webkitOutput;
    style['Moz' + capitalizeString(property)] = mozOutput;
    return outputValue;
  }
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/inline-style-prefixer@5.1.2/node_modules/inline-style-prefixer/es/index.js


















var plugins = [backgroundClip, crossFade, cursor, filter, flexboxOld, gradient, grid, imageSet, logical, position, sizing, transition, flex];

var es_prefix = createPrefixer({
  prefixMap: data.prefixMap,
  plugins: plugins
});


;// CONCATENATED MODULE: ../../node_modules/.pnpm/styletron-engine-monolithic@1.0.0/node_modules/styletron-engine-monolithic/dist-browser-esm/inject-style-prefixed.js



function injectStylePrefixed(styles, selector, prefix, strict) {
  let rules = "";
  let classes = [];

  for (const key in styles) {
    const value = styles[key];

    if (value === void 0 || value === null) {
      continue;
    }

    if (typeof value !== "object") {
      if (false) {}

      const rule = (0,hyphenate_style_name/* default */.Z)(key) + ":" + value;
      const prefixed = es_prefix({
        [key]: value
      });

      for (const prefixedKey in prefixed) {
        const prefixedVal = prefixed[prefixedKey];

        if (typeof prefixedVal === "string" || typeof prefixedVal === "number") {
          const prefixedRule = (0,hyphenate_style_name/* default */.Z)(prefixedKey) + ":" + prefixedVal;

          if (prefixedRule !== rule) {
            rules += prefixedRule + ";";
          }
        } else if (Array.isArray(prefixedVal)) {
          const hyphenated = (0,hyphenate_style_name/* default */.Z)(prefixedKey);

          for (let i = 0; i < prefixedVal.length; i++) {
            const prefixedRule = hyphenated + ":" + prefixedVal[i];

            if (prefixedRule !== rule) {
              rules += prefixedRule + ";";
            }
          }
        }
      }

      rules += rule + ";";
      continue;
    }

    if (key[0] === ":") {
      classes = [...classes, ...injectStylePrefixed(value, selector + key, prefix, strict)];
      continue;
    }

    if (key[0] === "@") {
      const nestedRules = injectStylePrefixed(value, selector, prefix, strict);
      classes = [...classes, key + "{" + nestedRules.join("") + "}"];
      continue;
    }

    classes = [...classes, key + "{" + injectStylePrefixed(value, "", prefix, strict).join("") + "}"];
  } // strict mode checks for mixed long/shorthands to keep compatibility with atomic engine


  if (strict && "production" !== "production") {} // used to handle 'exact' selectors like 'div' or referencing another class name like '.css-abc123:hover'
  // selector is applied in the parent recursive function call.


  if (!selector) {
    return [rules];
  }

  const result = [];

  if (rules) {
    result.push(`.${prefix}css-${selector}{${rules}}`);
  }

  return [...result, ...classes];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 96492:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export generateHtmlString */
/* harmony import */ var _inject_style_prefixed__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1693);
/* harmony import */ var _css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78736);



class StyletronServer {
  constructor(opts = {}) {
    this.opts = opts || {};
    this.cache = {};
  }

  renderStyle(styles) {
    const className = (0,_css__WEBPACK_IMPORTED_MODULE_0__/* .hashCssObject */ .Ab)(styles);

    if (!this.cache[className]) {
      this.cache[className] = (0,_inject_style_prefixed__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(styles, className, this.opts.prefix || "", Boolean(this.opts.strict)).join("");
    }

    return `${this.opts.prefix || ""}css-${className}`;
  }

  renderFontFace(fontFace) {
    const fontName = (0,_css__WEBPACK_IMPORTED_MODULE_0__/* .hashCssObject */ .Ab)(fontFace);

    if (!this.cache[fontName]) {
      this.cache[fontName] = (0,_css__WEBPACK_IMPORTED_MODULE_0__/* .fontFaceBlockToRule */ .cE)(`${this.opts.prefix || ""}font-${fontName}`, (0,_css__WEBPACK_IMPORTED_MODULE_0__/* .declarationsToBlock */ .Rk)(fontFace));
    }

    return `${this.opts.prefix || ""}font-${fontName}`;
  }

  renderKeyframes(keyframes) {
    const animationName = (0,_css__WEBPACK_IMPORTED_MODULE_0__/* .hashCssObject */ .Ab)(keyframes);

    if (!this.cache[animationName]) {
      this.cache[animationName] = (0,_css__WEBPACK_IMPORTED_MODULE_0__/* .keyframesBlockToRule */ .Rs)(`${this.opts.prefix || ""}animation-${animationName}`, (0,_css__WEBPACK_IMPORTED_MODULE_0__/* .keyframesToBlock */ .B4)(keyframes));
    }

    return `${this.opts.prefix || ""}animation-${animationName}`;
  }

  getStylesheets() {
    const hashedNames = [...Object.keys(this.cache)];
    return [{
      css: this.getCss(),
      attrs: {
        "data-hydrate": hashedNames.join(" ")
      }
    }];
  }

  getStylesheetsHtml(className = "_styletron_hydrate_") {
    return generateHtmlString(this.getStylesheets(), className);
  }

  getCss() {
    return [...Object.values(this.cache)].join("");
  }

}

function generateHtmlString(sheets, className) {
  let html = "";

  for (let i = 0; i < sheets.length; i++) {
    const sheet = sheets[i];
    const {
      class: originalClassName,
      ...rest
    } = sheet.attrs;
    const attrs = {
      class: originalClassName ? `${className} ${originalClassName}` : className,
      ...rest
    };
    html += `<style${attrsToString(attrs)}>${sheet.css}</style>`;
  }

  return html;
}

function attrsToString(attrs) {
  let result = "";

  for (const attr in attrs) {
    const value = attrs[attr];

    if (value === true) {
      result += " " + attr;
    } else if (value !== false) {
      result += ` ${attr}="${value}"`;
    }
  }

  return result;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StyletronServer);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 81262:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Le: () => (/* binding */ withWrapper),
/* harmony export */   Se: () => (/* binding */ createStyled),
/* harmony export */   WA: () => (/* binding */ DebugEngine),
/* harmony export */   hQ: () => (/* binding */ useStyletron),
/* harmony export */   w1: () => (/* binding */ withStyle),
/* harmony export */   zo: () => (/* binding */ styled),
/* harmony export */   zt: () => (/* binding */ Provider)
/* harmony export */ });
/* unused harmony exports withTransform, withStyleDeep, autoComposeShallow, autoComposeDeep, staticComposeShallow, staticComposeDeep, dynamicComposeShallow, dynamicComposeDeep, createShallowMergeReducer, createDeepMergeReducer, composeStatic, composeDynamic, createStyledElementComponent, resolveStyle */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var styletron_standard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98351);



/* eslint-env browser */

/* global module */
function addDebugMetadata(instance, stackIndex) {
  var _ref = new Error("stacktrace source"),
      stack = _ref.stack,
      stacktrace = _ref.stacktrace,
      message = _ref.message;

  instance.debug = {
    stackInfo: {
      stack: stack,
      stacktrace: stacktrace,
      message: message
    },
    stackIndex: stackIndex
  };
} // DEVTOOLS SETUP

var setupDevtoolsExtension = function setupDevtoolsExtension() {
  var atomicMap = {};
  var extensionsMap = new Map();
  var stylesMap = new Map();

  var getStyles = function getStyles(className) {
    var styles = {};

    if (typeof className !== "string") {
      return styles;
    }

    if (stylesMap.has(className)) {
      styles.styles = stylesMap.get(className);
      var classList = className.split(" ");

      if (classList.length) {
        var classes = {};
        classList.forEach(function (singleClassName) {
          classes[singleClassName] = atomicMap[singleClassName];
        });
        styles.classes = classes;
      }

      if (extensionsMap.has(className)) {
        var extension = extensionsMap.get(className);
        styles.extends = extension;
      }

      return styles;
    }
  };

  window.__STYLETRON_DEVTOOLS__ = {
    atomicMap: atomicMap,
    extensionsMap: extensionsMap,
    stylesMap: stylesMap,
    getStyles: getStyles
  };
};

var BrowserDebugEngine =
/*#__PURE__*/
function () {
  function BrowserDebugEngine(worker) {
    if (!worker) {
      var workerBlob = new Blob(["importScripts(\"https://unpkg.com/css-to-js-sourcemap-worker@2.0.5/worker.js\")"], {
        type: "application/javascript"
      });
      worker = new Worker(URL.createObjectURL(workerBlob));
      worker.postMessage({
        id: "init_wasm",
        url: "https://unpkg.com/css-to-js-sourcemap-worker@2.0.5/mappings.wasm"
      });
      worker.postMessage({
        id: "set_render_interval",
        interval: 120
      });

      if (false) {}
    }

    this.worker = worker;
    this.counter = 0;

    this.worker.onmessage = function (msg) {
      var _msg$data = msg.data,
          id = _msg$data.id,
          css = _msg$data.css;

      if (id === "render_css" && css) {
        var style = document.createElement("style");
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
      }
    };
  }

  var _proto = BrowserDebugEngine.prototype;

  _proto.debug = function debug(_ref2) {
    var stackIndex = _ref2.stackIndex,
        stackInfo = _ref2.stackInfo;
    var className = "__debug-" + this.counter++;
    this.worker.postMessage({
      id: "add_mapped_class",
      className: className,
      stackInfo: stackInfo,
      stackIndex: stackIndex
    });
    return className;
  };

  return BrowserDebugEngine;
}();

var DebugEngine = BrowserDebugEngine;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint-env browser */

/* eslint-disable no-unused-vars, no-redeclare, no-shadow */
var noopEngine = {
  renderStyle: function renderStyle() {
    return "";
  },
  renderKeyframes: function renderKeyframes() {
    return "";
  },
  renderFontFace: function renderFontFace() {
    return "";
  }
};
var StyletronContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(noopEngine);
var HydrationContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);
var DebugEngineContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();
var ThemeContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();

var DevProvider =
/*#__PURE__*/
(/* unused pure expression or super */ null && (function (_React$Component) {
  _inheritsLoose(DevProvider, _React$Component);

  function DevProvider(props) {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = {
      hydrating: Boolean(props.debugAfterHydration)
    };
    return _this;
  }

  var _proto = DevProvider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    {
      if (this.state.hydrating === true) {
        this.setState({
          hydrating: false
        });
      }
    }
  };

  _proto.render = function render() {
    return createElement(StyletronContext.Provider, {
      value: this.props.value
    }, createElement(DebugEngineContext.Provider, {
      value: this.props.debug
    }, createElement(HydrationContext.Provider, {
      value: this.state.hydrating
    }, this.props.children)));
  };

  return DevProvider;
}(Component)));

var Provider =  false ? 0 : StyletronContext.Provider;

if (false) {}

function checkNoopEngine(engine) {
  // if no engine provided, we default to no-op, handy for tests
  // however, print a warning in other envs
  if (true) {
    engine === noopEngine && // eslint-disable-next-line no-console
    console.warn( false ? 0 : "Styletron Provider is not set up. Defaulting to no-op.");
  }
}

function useStyletron() {
  var styletronEngine = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StyletronContext);
  var debugEngine = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(DebugEngineContext);
  var hydrating = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HydrationContext);
  checkNoopEngine(styletronEngine);
  var debugClassName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)("");
  var prevDebugClassNameDeps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
  return [function css(style) {
    var className = (0,styletron_standard__WEBPACK_IMPORTED_MODULE_1__/* .driver */ .vC)(style, styletronEngine);

    if (true) {
      return className;
    }

    var _ref = new Error("stacktrace source"),
        stack = _ref.stack,
        message = _ref.message;

    var nextDeps = [debugEngine, hydrating];

    if (prevDebugClassNameDeps.current[0] !== nextDeps[0] || prevDebugClassNameDeps.current[1] !== nextDeps[1]) {
      if (debugEngine && !hydrating) {
        debugClassName.current = debugEngine.debug({
          stackInfo: {
            stack: stack,
            message: message
          },
          stackIndex: 1
        });
      }

      prevDebugClassNameDeps.current = nextDeps;
    }

    if (debugClassName.current) {
      return debugClassName.current + " " + className;
    }

    return className;
  }];
}
function createStyled(_ref2) {
  var getInitialStyle$$1 = _ref2.getInitialStyle,
      driver$$1 = _ref2.driver,
      wrapper = _ref2.wrapper;

  function styled(base, styleArg) {
    if (false) {}

    var baseStyletron = {
      reducers: [],
      base: base,
      driver: driver$$1,
      getInitialStyle: getInitialStyle$$1,
      wrapper: wrapper
    };

    if (false) {}

    return createStyledElementComponent(autoComposeShallow(baseStyletron, styleArg));
  }

  return styled;
}
var styled = createStyled({
  getInitialStyle: styletron_standard__WEBPACK_IMPORTED_MODULE_1__/* .getInitialStyle */ .r4,
  driver: styletron_standard__WEBPACK_IMPORTED_MODULE_1__/* .driver */ .vC,
  wrapper: function wrapper(Component$$1) {
    return Component$$1;
  }
});
function withTransform(component, transformer) {
  var styletron = component.__STYLETRON__;

  if (false) {}

  return createStyledElementComponent(composeDynamic(styletron, transformer));
}
var withStyle = withStyleDeep;
function withStyleDeep(component, styleArg) {
  var styletron = component.__STYLETRON__;

  if (false) {}

  if (false) {} else {
    return createStyledElementComponent(autoComposeDeep(styletron, styleArg));
  }
}
function withWrapper(component, wrapper) {
  var styletron = component.__STYLETRON__;

  if (false) {}

  var composed = {
    getInitialStyle: styletron.getInitialStyle,
    base: styletron.base,
    driver: styletron.driver,
    wrapper: wrapper,
    reducers: styletron.reducers
  };

  if (false) {}

  return createStyledElementComponent(composed);
}
function autoComposeShallow(styletron, styleArg) {
  if (typeof styleArg === "function") {
    return dynamicComposeShallow(styletron, styleArg);
  }

  return staticComposeShallow(styletron, styleArg);
}

function addExtension(composed, component, styleArg) {
  return Object.assign({}, composed, {
    ext: {
      with: styleArg,
      name: component.displayName,
      base: component.__STYLETRON__.base,
      getInitialStyle: component.__STYLETRON__.reducers.length ? component.__STYLETRON__.reducers[0].reducer : component.__STYLETRON__.getInitialStyle
    }
  });
}

function autoComposeDeep(styletron, styleArg) {
  if (typeof styleArg === "function") {
    return dynamicComposeDeep(styletron, styleArg);
  }

  return staticComposeDeep(styletron, styleArg);
}
function staticComposeShallow(styletron, style) {
  return composeStatic(styletron, createShallowMergeReducer(style));
}
function staticComposeDeep(styletron, style) {
  return composeStatic(styletron, createDeepMergeReducer(style));
}
function dynamicComposeShallow(styletron, styleFn) {
  return composeDynamic(styletron, function (style, props) {
    return shallowMerge(style, styleFn(props));
  });
}
function dynamicComposeDeep(styletron, styleFn) {
  return composeDynamic(styletron, function (style, props) {
    return deepMerge(style, styleFn(props));
  });
}
function createShallowMergeReducer(style) {
  return {
    reducer: function reducer(inputStyle) {
      return shallowMerge(inputStyle, style);
    },
    assignmentCommutative: true,
    factory: createShallowMergeReducer,
    style: style
  };
}
function createDeepMergeReducer(style) {
  return {
    reducer: function reducer(inputStyle) {
      return deepMerge(inputStyle, style);
    },
    assignmentCommutative: true,
    factory: createDeepMergeReducer,
    style: style
  };
}
function composeStatic(styletron, reducerContainer) {
  if (styletron.reducers.length === 0) {
    var style = reducerContainer.reducer(styletron.getInitialStyle());
    var result = {
      reducers: styletron.reducers,
      base: styletron.base,
      driver: styletron.driver,
      wrapper: styletron.wrapper,
      getInitialStyle: function getInitialStyle$$1() {
        return style;
      }
    };

    if (false) {}

    return result;
  } else {
    var last = styletron.reducers[0];

    if (last.assignmentCommutative === true && reducerContainer.assignmentCommutative === true) {
      var composed = reducerContainer.reducer(last.style);
      var _result = {
        getInitialStyle: styletron.getInitialStyle,
        base: styletron.base,
        driver: styletron.driver,
        wrapper: styletron.wrapper,
        reducers: [last.factory(composed)].concat(styletron.reducers.slice(1))
      };

      if (false) {}

      return _result;
    }

    return composeDynamic(styletron, reducerContainer.reducer);
  }
}
function composeDynamic(styletron, reducer) {
  var composed = {
    getInitialStyle: styletron.getInitialStyle,
    base: styletron.base,
    driver: styletron.driver,
    wrapper: styletron.wrapper,
    reducers: [{
      assignmentCommutative: false,
      reducer: reducer
    }].concat(styletron.reducers)
  };

  if (false) {}

  return composed;
}
function createStyledElementComponent(styletron) {
  var reducers = styletron.reducers,
      base = styletron.base,
      driver$$1 = styletron.driver,
      wrapper = styletron.wrapper,
      getInitialStyle$$1 = styletron.getInitialStyle,
      ext = styletron.ext;

  if (false) { var debugStackInfo, debugStackIndex; }

  if (false) { var debugClassName; }

  var StyledElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    var styletron = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StyletronContext);
    var debugEngine = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(DebugEngineContext);
    var hydrating = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HydrationContext);
    checkNoopEngine(styletron);
    var elementProps = omitPrefixedKeys(props);
    var style = resolveStyle(getInitialStyle$$1, reducers, props);

    if (props.$style) {
      if (typeof props.$style === "function") {
        style = deepMerge(style, props.$style(props));
      } else {
        style = deepMerge(style, props.$style);
      }
    }

    var styleClassString = driver$$1(style, styletron);
    var Element = props.$as ? props.$as : base;
    elementProps.className = props.className ? props.className + " " + styleClassString : styleClassString;

    if (false) { var joined; }

    if (false) {}

    if (props.$ref) {
      // eslint-disable-next-line no-console
      console.warn("The prop `$ref` has been deprecated. Use `ref` instead. Refs are now forwarded with React.forwardRef.");
    }

    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Element, _extends({}, elementProps, {
      ref: ref || props.$ref
    }));
  });
  var Wrapped = wrapper(StyledElement);
  Wrapped.__STYLETRON__ = {
    base: base,
    reducers: reducers,
    driver: driver$$1,
    wrapper: wrapper,
    getInitialStyle: getInitialStyle$$1
  };

  if (false) { var displayName; }

  return Wrapped;
} // Utility functions

function resolveStyle(getInitialStyle$$1, reducers, props) {
  var result = getInitialStyle$$1();
  var i = reducers.length;

  while (i--) {
    // Cast to allow passing unused props param in case of static reducer
    var reducer = reducers[i].reducer;
    result = reducer(result, props);
  }

  return result;
}

function isObject(x) {
  return _typeof(x) === "object" && x !== null;
}

function omitPrefixedKeys(source) {
  var result = {};

  for (var key in source) {
    if (key[0] !== "$") {
      result[key] = source[key];
    }
  }

  return result;
}

function deepMerge(a, b) {
  var result = assign({}, a);

  for (var key in b) {
    var val = b[key];

    if (isObject(val) && isObject(a[key])) {
      result[key] = deepMerge(a[key], val);
    } else {
      result[key] = val;
    }
  }

  return result;
}

function shallowMerge(a, b) {
  return assign(assign({}, a), b);
}

function assign(target, source) {
  for (var key in source) {
    target[key] = source[key];
  }

  return target;
}


//# sourceMappingURL=browser.es5.es.js.map


/***/ }),

/***/ 98351:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r4: () => (/* binding */ getInitialStyle),
/* harmony export */   vC: () => (/* binding */ driver)
/* harmony export */ });
/* unused harmony export renderDeclarativeRules */
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Note: $Shape is needed to make polymorphic withStyle refinements work correctly
// It seems functions satisfy this type without $Shape
// See: https://github.com/facebook/flow/issues/6784
//
//
//
//
//
//
function driver(style, styletron) {
  var tx = renderDeclarativeRules(style, styletron);
  return styletron.renderStyle(tx);
}
function getInitialStyle() {
  return {};
}
function renderDeclarativeRules(style, styletron) {
  for (var key in style) {
    var val = style[key];

    if (key === "animationName" && typeof val !== "string") {
      style.animationName = styletron.renderKeyframes(val);
      continue;
    }

    if (key === "fontFamily" && typeof val !== "string") {
      if (Array.isArray(val)) {
        var result = "";

        for (var _iterator = val, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var _font = _ref;

          if (_typeof(_font) === "object") {
            result += styletron.renderFontFace(_font) + ",";
          } else if (typeof _font === "string") {
            result += _font + ",";
          }
        }

        style.fontFamily = result.slice(0, -1);
        continue;
      } else if (val === void 0) {
        continue;
      } else {
        style.fontFamily = styletron.renderFontFace(val);
        continue;
      }
    }

    if (_typeof(val) === "object" && val !== null) {
      renderDeclarativeRules(val, styletron);
    }
  }

  return style;
}


//# sourceMappingURL=browser.es5.es.js.map


/***/ }),

/***/ 4048:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  q: () => (/* binding */ useMergeRefs)
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/use-callback-ref@1.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/use-callback-ref@1.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/use-callback-ref@1.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/use-callback-ref/dist/es2015/useMergeRef.js


/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    return useCallbackRef(defaultValue || null, function (newValue) { return refs.forEach(function (ref) { return assignRef(ref, newValue); }); });
}


/***/ }),

/***/ 93711:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: () => (/* binding */ createSidecarMedium),
/* harmony export */   s: () => (/* binding */ createMedium)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43112);

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ async: true, ssr: false }, options);
    return medium;
}


/***/ }),

/***/ 45233:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _defineProperty)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65286);

function _defineProperty(obj, key, value) {
  key = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ 65286:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ _toPropertyKey)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@babel+runtime@7.20.7/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(46722);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@babel+runtime@7.20.7/node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if ((0,esm_typeof/* default */.Z)(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,esm_typeof/* default */.Z)(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@babel+runtime@7.20.7/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (0,esm_typeof/* default */.Z)(key) === "symbol" ? key : String(key);
}

/***/ }),

/***/ 46722:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _typeof)
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

}]);